import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { Base64 } from 'js-base64';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
const BASE_PATH = "http://localhost:9000".replace(/\/+$/, "");
class Configuration {
    constructor(configuration = {}) {
        Object.defineProperty(this, "configuration", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: configuration
        });
    }
    set config(configuration) {
        this.configuration = configuration;
    }
    get basePath() {
        return this.configuration.basePath != null ? this.configuration.basePath : BASE_PATH;
    }
    get fetchApi() {
        return this.configuration.fetchApi;
    }
    get middleware() {
        return this.configuration.middleware || [];
    }
    get queryParamsStringify() {
        return this.configuration.queryParamsStringify || querystring;
    }
    get username() {
        return this.configuration.username;
    }
    get password() {
        return this.configuration.password;
    }
    get apiKey() {
        const apiKey = this.configuration.apiKey;
        if (apiKey) {
            return typeof apiKey === 'function' ? apiKey : () => apiKey;
        }
        return undefined;
    }
    get accessToken() {
        const accessToken = this.configuration.accessToken;
        if (accessToken) {
            return typeof accessToken === 'function' ? accessToken : () => __awaiter(this, void 0, void 0, function* () { return accessToken; });
        }
        return undefined;
    }
    get headers() {
        return this.configuration.headers;
    }
    get credentials() {
        return this.configuration.credentials;
    }
}
const DefaultConfig = new Configuration();
/**
 * This is the base class for all generated API classes.
 */
class BaseAPI {
    constructor(configuration = DefaultConfig) {
        Object.defineProperty(this, "configuration", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: configuration
        });
        Object.defineProperty(this, "middleware", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fetchApi", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (url, init) => __awaiter(this, void 0, void 0, function* () {
                let fetchParams = { url, init };
                for (const middleware of this.middleware) {
                    if (middleware.pre) {
                        fetchParams = (yield middleware.pre(Object.assign({ fetch: this.fetchApi }, fetchParams))) || fetchParams;
                    }
                }
                let response = undefined;
                try {
                    response = yield (this.configuration.fetchApi || fetch)(fetchParams.url, fetchParams.init);
                }
                catch (e) {
                    for (const middleware of this.middleware) {
                        if (middleware.onError) {
                            response = (yield middleware.onError({
                                fetch: this.fetchApi,
                                url: fetchParams.url,
                                init: fetchParams.init,
                                error: e,
                                response: response ? response.clone() : undefined,
                            })) || response;
                        }
                    }
                    if (response === undefined) {
                        if (e instanceof Error) {
                            throw new FetchError(e, 'The request failed and the interceptors did not return an alternative response');
                        }
                        else {
                            throw e;
                        }
                    }
                }
                for (const middleware of this.middleware) {
                    if (middleware.post) {
                        response = (yield middleware.post({
                            fetch: this.fetchApi,
                            url: fetchParams.url,
                            init: fetchParams.init,
                            response: response.clone(),
                        })) || response;
                    }
                }
                return response;
            })
        });
        this.middleware = configuration.middleware;
    }
    withMiddleware(...middlewares) {
        const next = this.clone();
        next.middleware = next.middleware.concat(...middlewares);
        return next;
    }
    withPreMiddleware(...preMiddlewares) {
        const middlewares = preMiddlewares.map((pre) => ({ pre }));
        return this.withMiddleware(...middlewares);
    }
    withPostMiddleware(...postMiddlewares) {
        const middlewares = postMiddlewares.map((post) => ({ post }));
        return this.withMiddleware(...middlewares);
    }
    request(context, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const { url, init } = yield this.createFetchParams(context, initOverrides);
            const response = yield this.fetchApi(url, init);
            if (response && (response.status >= 200 && response.status < 300)) {
                return response;
            }
            throw new ResponseError(response, 'Response returned an error code');
        });
    }
    createFetchParams(context, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            let url = this.configuration.basePath + context.path;
            if (context.query !== undefined && Object.keys(context.query).length !== 0) {
                // only add the querystring to the URL if there are query parameters.
                // this is done to avoid urls ending with a "?" character which buggy webservers
                // do not handle correctly sometimes.
                url += '?' + this.configuration.queryParamsStringify(context.query);
            }
            const headers = Object.assign({}, this.configuration.headers, context.headers);
            Object.keys(headers).forEach(key => headers[key] === undefined ? delete headers[key] : {});
            const initOverrideFn = typeof initOverrides === "function"
                ? initOverrides
                : () => __awaiter(this, void 0, void 0, function* () { return initOverrides; });
            const initParams = {
                method: context.method,
                headers,
                body: context.body,
                credentials: this.configuration.credentials,
            };
            const overridedInit = Object.assign(Object.assign({}, initParams), (yield initOverrideFn({
                init: initParams,
                context,
            })));
            const init = Object.assign(Object.assign({}, overridedInit), { body: isFormData(overridedInit.body) ||
                    overridedInit.body instanceof URLSearchParams ||
                    isBlob(overridedInit.body)
                    ? overridedInit.body
                    : JSON.stringify(overridedInit.body) });
            return { url, init };
        });
    }
    /**
     * Create a shallow clone of `this` by constructing a new instance
     * and then shallow cloning data members.
     */
    clone() {
        const constructor = this.constructor;
        const next = new constructor(this.configuration);
        next.middleware = this.middleware.slice();
        return next;
    }
}
function isBlob(value) {
    return typeof Blob !== 'undefined' && value instanceof Blob;
}
function isFormData(value) {
    return typeof FormData !== "undefined" && value instanceof FormData;
}
class ResponseError extends Error {
    constructor(response, msg) {
        super(msg);
        Object.defineProperty(this, "response", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: response
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ResponseError"
        });
    }
}
class FetchError extends Error {
    constructor(cause, msg) {
        super(msg);
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "FetchError"
        });
    }
}
class RequiredError extends Error {
    constructor(field, msg) {
        super(msg);
        Object.defineProperty(this, "field", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: field
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "RequiredError"
        });
    }
}
const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
function exists(json, key) {
    const value = json[key];
    return value !== null && value !== undefined;
}
function querystring(params, prefix = '') {
    return Object.keys(params)
        .map(key => querystringSingleKey(key, params[key], prefix))
        .filter(part => part.length > 0)
        .join('&');
}
function querystringSingleKey(key, value, keyPrefix = '') {
    const fullKey = keyPrefix + (keyPrefix.length ? `[${key}]` : key);
    if (value instanceof Array) {
        const multiValue = value.map(singleValue => encodeURIComponent(String(singleValue)))
            .join(`&${encodeURIComponent(fullKey)}=`);
        return `${encodeURIComponent(fullKey)}=${multiValue}`;
    }
    if (value instanceof Set) {
        const valueAsArray = Array.from(value);
        return querystringSingleKey(key, valueAsArray, keyPrefix);
    }
    if (value instanceof Date) {
        return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value.toISOString())}`;
    }
    if (value instanceof Object) {
        return querystring(value, fullKey);
    }
    return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
}
function mapValues(data, fn) {
    return Object.keys(data).reduce((acc, key) => (Object.assign(Object.assign({}, acc), { [key]: fn(data[key]) })), {});
}
function canConsumeForm(consumes) {
    for (const consume of consumes) {
        if ('multipart/form-data' === consume.contentType) {
            return true;
        }
    }
    return false;
}
class JSONApiResponse {
    constructor(raw, transformer = (jsonValue) => jsonValue) {
        Object.defineProperty(this, "raw", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: raw
        });
        Object.defineProperty(this, "transformer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: transformer
        });
    }
    value() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.transformer(yield this.raw.json());
        });
    }
}
class VoidApiResponse {
    constructor(raw) {
        Object.defineProperty(this, "raw", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: raw
        });
    }
    value() {
        return __awaiter(this, void 0, void 0, function* () {
            return undefined;
        });
    }
}
class BlobApiResponse {
    constructor(raw) {
        Object.defineProperty(this, "raw", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: raw
        });
    }
    value() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.raw.blob();
        });
    }
    ;
}
class TextApiResponse {
    constructor(raw) {
        Object.defineProperty(this, "raw", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: raw
        });
    }
    value() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.raw.text();
        });
    }
    ;
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const ApiExchangeMissingExecutionErrorTypeEnum = {
    API_EXCHANGE_MISSING: 'API_EXCHANGE_MISSING'
};
/**
 * Check if a given object implements the ApiExchangeMissingExecutionError interface.
 */
function instanceOfApiExchangeMissingExecutionError(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function ApiExchangeMissingExecutionErrorFromJSON(json) {
    return ApiExchangeMissingExecutionErrorFromJSONTyped(json);
}
function ApiExchangeMissingExecutionErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nodeId': !exists(json, 'nodeId') ? undefined : json['nodeId'],
        'type': json['type'],
    };
}
function ApiExchangeMissingExecutionErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nodeId': value.nodeId,
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
const AttributeValueType = {
    TICKET_STATUS: 'TICKET_STATUS',
    STRING: 'STRING',
    NUMBER: 'NUMBER',
    DATE: 'DATE',
    BOOLEAN: 'BOOLEAN'
};
function AttributeValueTypeFromJSON(json) {
    return AttributeValueTypeFromJSONTyped(json);
}
function AttributeValueTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function AttributeValueTypeToJSON(value) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the KNSFile interface.
 */
function instanceOfKNSFile(value) {
    let isInstance = true;
    isInstance = isInstance && "dateCreated" in value;
    isInstance = isInstance && "extension" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "size" in value;
    return isInstance;
}
function KNSFileFromJSON(json) {
    return KNSFileFromJSONTyped(json);
}
function KNSFileFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'dateCreated': json['dateCreated'],
        'extension': json['extension'],
        'id': json['id'],
        'name': json['name'],
        'size': json['size'],
    };
}
function KNSFileToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'dateCreated': value.dateCreated,
        'extension': value.extension,
        'id': value.id,
        'name': value.name,
        'size': value.size,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FileReference interface.
 */
function instanceOfFileReference(value) {
    let isInstance = true;
    isInstance = isInstance && "file" in value;
    return isInstance;
}
function FileReferenceFromJSON(json) {
    return FileReferenceFromJSONTyped(json);
}
function FileReferenceFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'caption': !exists(json, 'caption') ? undefined : json['caption'],
        'file': KNSFileFromJSON(json['file']),
    };
}
function FileReferenceToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'caption': value.caption,
        'file': KNSFileToJSON(value.file),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the BaseChoice interface.
 */
function instanceOfBaseChoice(value) {
    let isInstance = true;
    return isInstance;
}
function BaseChoiceFromJSON(json) {
    return BaseChoiceFromJSONTyped(json);
}
function BaseChoiceFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'annotation': !exists(json, 'annotation') ? undefined : json['annotation'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'media': !exists(json, 'media') ? undefined : FileReferenceFromJSON(json['media']),
    };
}
function BaseChoiceToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'annotation': value.annotation,
        'label': value.label,
        'media': FileReferenceToJSON(value.media),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const BooleanDataValueTypeEnum = {
    BOOLEAN: 'BOOLEAN'
};
/**
 * Check if a given object implements the BooleanDataValue interface.
 */
function instanceOfBooleanDataValue(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "value" in value;
    return isInstance;
}
function BooleanDataValueFromJSON(json) {
    return BooleanDataValueFromJSONTyped(json);
}
function BooleanDataValueFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': json['type'],
        'value': json['value'],
    };
}
function BooleanDataValueToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
        'value': value.value,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
const DataValueType = {
    STRING: 'STRING',
    FILE: 'FILE',
    BOOLEAN: 'BOOLEAN',
    DATE: 'DATE',
    NUMBER: 'NUMBER',
    RICH_TEXT: 'RICH_TEXT'
};
function DataValueTypeFromJSON(json) {
    return DataValueTypeFromJSONTyped(json);
}
function DataValueTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function DataValueTypeToJSON(value) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the BooleanDataValueAllOf interface.
 */
function instanceOfBooleanDataValueAllOf(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "value" in value;
    return isInstance;
}
function BooleanDataValueAllOfFromJSON(json) {
    return BooleanDataValueAllOfFromJSONTyped(json);
}
function BooleanDataValueAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': DataValueTypeFromJSON(json['type']),
        'value': json['value'],
    };
}
function BooleanDataValueAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': DataValueTypeToJSON(value.type),
        'value': value.value,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const BooleanDataValueAllOf1TypeEnum = {
    BOOLEAN: 'BOOLEAN'
};
/**
 * Check if a given object implements the BooleanDataValueAllOf1 interface.
 */
function instanceOfBooleanDataValueAllOf1(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function BooleanDataValueAllOf1FromJSON(json) {
    return BooleanDataValueAllOf1FromJSONTyped(json);
}
function BooleanDataValueAllOf1FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': json['type'],
    };
}
function BooleanDataValueAllOf1ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
const BooleanDisplayType = {
    RADIO_BUTTONS: 'RADIO_BUTTONS',
    CHECKBOX: 'CHECKBOX'
};
function BooleanDisplayTypeFromJSON(json) {
    return BooleanDisplayTypeFromJSONTyped(json);
}
function BooleanDisplayTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function BooleanDisplayTypeToJSON(value) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const BooleanNodeInputTypeEnum = {
    BOOLEAN: 'BOOLEAN'
};
/**
 * Check if a given object implements the BooleanNodeInput interface.
 */
function instanceOfBooleanNodeInput(value) {
    let isInstance = true;
    isInstance = isInstance && "value" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function BooleanNodeInputFromJSON(json) {
    return BooleanNodeInputFromJSONTyped(json);
}
function BooleanNodeInputFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'value': json['value'],
        'type': json['type'],
    };
}
function BooleanNodeInputToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'value': value.value,
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ChatActionOutline interface.
 */
function instanceOfChatActionOutline(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "label" in value;
    return isInstance;
}
function ChatActionOutlineFromJSON(json) {
    return ChatActionOutlineFromJSONTyped(json);
}
function ChatActionOutlineFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'description': !exists(json, 'description') ? undefined : json['description'],
        'falseLabel': !exists(json, 'falseLabel') ? undefined : json['falseLabel'],
        'id': json['id'],
        'label': json['label'],
    };
}
function ChatActionOutlineToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'description': value.description,
        'falseLabel': value.falseLabel,
        'id': value.id,
        'label': value.label,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const ChatNodeDataTargetNodeTypeEnum = {
    CHAT: 'CHAT'
};
/**
 * Check if a given object implements the ChatNodeData interface.
 */
function instanceOfChatNodeData(value) {
    let isInstance = true;
    isInstance = isInstance && "targetNodeType" in value;
    return isInstance;
}
function ChatNodeDataFromJSON(json) {
    return ChatNodeDataFromJSONTyped(json);
}
function ChatNodeDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'actionId': !exists(json, 'actionId') ? undefined : json['actionId'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'targetNodeType': json['targetNodeType'],
    };
}
function ChatNodeDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'actionId': value.actionId,
        'message': value.message,
        'targetNodeType': value.targetNodeType,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the Choice interface.
 */
function instanceOfChoice(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "idx" in value;
    return isInstance;
}
function ChoiceFromJSON(json) {
    return ChoiceFromJSONTyped(json);
}
function ChoiceFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'annotation': !exists(json, 'annotation') ? undefined : json['annotation'],
        'id': json['id'],
        'idx': json['idx'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'media': !exists(json, 'media') ? undefined : FileReferenceFromJSON(json['media']),
    };
}
function ChoiceToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'annotation': value.annotation,
        'id': value.id,
        'idx': value.idx,
        'label': value.label,
        'media': FileReferenceToJSON(value.media),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ColorConfig interface.
 */
function instanceOfColorConfig(value) {
    let isInstance = true;
    return isInstance;
}
function ColorConfigFromJSON(json) {
    return ColorConfigFromJSONTyped(json);
}
function ColorConfigFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'accent': !exists(json, 'accent') ? undefined : json['accent'],
        'accentContrast': !exists(json, 'accentContrast') ? undefined : json['accentContrast'],
        'background': !exists(json, 'background') ? undefined : json['background'],
        'backgroundContrast': !exists(json, 'backgroundContrast') ? undefined : json['backgroundContrast'],
        'primary': !exists(json, 'primary') ? undefined : json['primary'],
        'primaryContrast': !exists(json, 'primaryContrast') ? undefined : json['primaryContrast'],
        'secondary': !exists(json, 'secondary') ? undefined : json['secondary'],
        'secondaryContrast': !exists(json, 'secondaryContrast') ? undefined : json['secondaryContrast'],
        'surface': !exists(json, 'surface') ? undefined : json['surface'],
        'surfaceContrast': !exists(json, 'surfaceContrast') ? undefined : json['surfaceContrast'],
    };
}
function ColorConfigToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'accent': value.accent,
        'accentContrast': value.accentContrast,
        'background': value.background,
        'backgroundContrast': value.backgroundContrast,
        'primary': value.primary,
        'primaryContrast': value.primaryContrast,
        'secondary': value.secondary,
        'secondaryContrast': value.secondaryContrast,
        'surface': value.surface,
        'surfaceContrast': value.surfaceContrast,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const DateDataValueTypeEnum = {
    DATE: 'DATE'
};
/**
 * Check if a given object implements the DateDataValue interface.
 */
function instanceOfDateDataValue(value) {
    let isInstance = true;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function DateDataValueFromJSON(json) {
    return DateDataValueFromJSONTyped(json);
}
function DateDataValueFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'date': json['date'],
        'type': json['type'],
    };
}
function DateDataValueToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'date': value.date,
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const FileDataValueTypeEnum = {
    FILE: 'FILE'
};
/**
 * Check if a given object implements the FileDataValue interface.
 */
function instanceOfFileDataValue(value) {
    let isInstance = true;
    isInstance = isInstance && "file" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function FileDataValueFromJSON(json) {
    return FileDataValueFromJSONTyped(json);
}
function FileDataValueFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'file': KNSFileFromJSON(json['file']),
        'type': json['type'],
    };
}
function FileDataValueToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'file': KNSFileToJSON(value.file),
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const NumberDataValueTypeEnum = {
    NUMBER: 'NUMBER'
};
/**
 * Check if a given object implements the NumberDataValue interface.
 */
function instanceOfNumberDataValue(value) {
    let isInstance = true;
    isInstance = isInstance && "number" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function NumberDataValueFromJSON(json) {
    return NumberDataValueFromJSONTyped(json);
}
function NumberDataValueFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'number': json['number'],
        'type': json['type'],
    };
}
function NumberDataValueToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'number': value.number,
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
const TextFormat = {
    BOLD: 'BOLD',
    ITALIC: 'ITALIC',
    UNDERLINE: 'UNDERLINE'
};
function TextFormatFromJSON(json) {
    return TextFormatFromJSONTyped(json);
}
function TextFormatFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function TextFormatToJSON(value) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const RichTextDataFieldNodeTypeEnum = {
    DATA_FIELD: 'DATA_FIELD'
};
/**
 * Check if a given object implements the RichTextDataFieldNode interface.
 */
function instanceOfRichTextDataFieldNode(value) {
    let isInstance = true;
    isInstance = isInstance && "dataFieldId" in value;
    isInstance = isInstance && "format" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function RichTextDataFieldNodeFromJSON(json) {
    return RichTextDataFieldNodeFromJSONTyped(json);
}
function RichTextDataFieldNodeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'dataFieldId': json['dataFieldId'],
        'format': (json['format'].map(TextFormatFromJSON)),
        'type': json['type'],
    };
}
function RichTextDataFieldNodeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'dataFieldId': value.dataFieldId,
        'format': (value.format.map(TextFormatToJSON)),
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const RichTextLineBreakNodeTypeEnum = {
    LINE_BREAK: 'LINE_BREAK'
};
/**
 * Check if a given object implements the RichTextLineBreakNode interface.
 */
function instanceOfRichTextLineBreakNode(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function RichTextLineBreakNodeFromJSON(json) {
    return RichTextLineBreakNodeFromJSONTyped(json);
}
function RichTextLineBreakNodeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': json['type'],
    };
}
function RichTextLineBreakNodeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const RichTextTextNodeTypeEnum = {
    TEXT: 'TEXT'
};
/**
 * Check if a given object implements the RichTextTextNode interface.
 */
function instanceOfRichTextTextNode(value) {
    let isInstance = true;
    isInstance = isInstance && "format" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function RichTextTextNodeFromJSON(json) {
    return RichTextTextNodeFromJSONTyped(json);
}
function RichTextTextNodeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'format': (json['format'].map(TextFormatFromJSON)),
        'text': !exists(json, 'text') ? undefined : json['text'],
        'type': json['type'],
    };
}
function RichTextTextNodeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'format': (value.format.map(TextFormatToJSON)),
        'text': value.text,
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const RichTextLinkNodeTypeEnum = {
    LINK: 'LINK'
};
/**
 * Check if a given object implements the RichTextLinkNode interface.
 */
function instanceOfRichTextLinkNode(value) {
    let isInstance = true;
    isInstance = isInstance && "children" in value;
    isInstance = isInstance && "url" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function RichTextLinkNodeFromJSON(json) {
    return RichTextLinkNodeFromJSONTyped(json);
}
function RichTextLinkNodeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'children': (json['children'].map(RichTextTextNodeFromJSON)),
        'url': json['url'],
        'type': json['type'],
    };
}
function RichTextLinkNodeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'children': (value.children.map(RichTextTextNodeToJSON)),
        'url': value.url,
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const RichTextListItemNodeTypeEnum = {
    LIST_ITEM: 'LIST_ITEM'
};
/**
 * Check if a given object implements the RichTextListItemNode interface.
 */
function instanceOfRichTextListItemNode(value) {
    let isInstance = true;
    isInstance = isInstance && "children" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function RichTextListItemNodeFromJSON(json) {
    return RichTextListItemNodeFromJSONTyped(json);
}
function RichTextListItemNodeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'children': (json['children'].map(RichTextNodeFromJSON)),
        'type': json['type'],
    };
}
function RichTextListItemNodeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'children': (value.children.map(RichTextNodeToJSON)),
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
const ListType = {
    BULLET: 'BULLET',
    NUMBER: 'NUMBER'
};
function ListTypeFromJSON(json) {
    return ListTypeFromJSONTyped(json);
}
function ListTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ListTypeToJSON(value) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const RichTextListNodeTypeEnum = {
    LIST: 'LIST'
};
/**
 * Check if a given object implements the RichTextListNode interface.
 */
function instanceOfRichTextListNode(value) {
    let isInstance = true;
    isInstance = isInstance && "children" in value;
    isInstance = isInstance && "listType" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function RichTextListNodeFromJSON(json) {
    return RichTextListNodeFromJSONTyped(json);
}
function RichTextListNodeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'children': (json['children'].map(RichTextListItemNodeFromJSON)),
        'listType': ListTypeFromJSON(json['listType']),
        'type': json['type'],
    };
}
function RichTextListNodeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'children': (value.children.map(RichTextListItemNodeToJSON)),
        'listType': ListTypeToJSON(value.listType),
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
const HeadingLevel = {
    H1: 'H1',
    H2: 'H2',
    H3: 'H3'
};
function HeadingLevelFromJSON(json) {
    return HeadingLevelFromJSONTyped(json);
}
function HeadingLevelFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function HeadingLevelToJSON(value) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
const TextAlignment = {
    LEFT: 'LEFT',
    CENTER: 'CENTER',
    RIGHT: 'RIGHT',
    JUSTIFY: 'JUSTIFY'
};
function TextAlignmentFromJSON(json) {
    return TextAlignmentFromJSONTyped(json);
}
function TextAlignmentFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function TextAlignmentToJSON(value) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const RichTextParagraphNodeTypeEnum = {
    PARAGRAPH: 'PARAGRAPH'
};
/**
 * Check if a given object implements the RichTextParagraphNode interface.
 */
function instanceOfRichTextParagraphNode(value) {
    let isInstance = true;
    isInstance = isInstance && "children" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function RichTextParagraphNodeFromJSON(json) {
    return RichTextParagraphNodeFromJSONTyped(json);
}
function RichTextParagraphNodeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'alignment': !exists(json, 'alignment') ? undefined : TextAlignmentFromJSON(json['alignment']),
        'children': (json['children'].map(RichTextNodeFromJSON)),
        'headingLevel': !exists(json, 'headingLevel') ? undefined : HeadingLevelFromJSON(json['headingLevel']),
        'type': json['type'],
    };
}
function RichTextParagraphNodeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'alignment': TextAlignmentToJSON(value.alignment),
        'children': (value.children.map(RichTextNodeToJSON)),
        'headingLevel': HeadingLevelToJSON(value.headingLevel),
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const RichTextRootNodeTypeEnum = {
    ROOT: 'ROOT'
};
/**
 * Check if a given object implements the RichTextRootNode interface.
 */
function instanceOfRichTextRootNode(value) {
    let isInstance = true;
    isInstance = isInstance && "children" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function RichTextRootNodeFromJSON(json) {
    return RichTextRootNodeFromJSONTyped(json);
}
function RichTextRootNodeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'children': (json['children'].map(RichTextNodeFromJSON)),
        'type': json['type'],
    };
}
function RichTextRootNodeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'children': (value.children.map(RichTextNodeToJSON)),
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const RichTextTableCellNodeTypeEnum = {
    TABLE_CELL: 'TABLE_CELL'
};
/**
 * Check if a given object implements the RichTextTableCellNode interface.
 */
function instanceOfRichTextTableCellNode(value) {
    let isInstance = true;
    isInstance = isInstance && "children" in value;
    isInstance = isInstance && "isHeader" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function RichTextTableCellNodeFromJSON(json) {
    return RichTextTableCellNodeFromJSONTyped(json);
}
function RichTextTableCellNodeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'children': (json['children'].map(RichTextParagraphNodeFromJSON)),
        'isHeader': json['isHeader'],
        'type': json['type'],
    };
}
function RichTextTableCellNodeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'children': (value.children.map(RichTextParagraphNodeToJSON)),
        'isHeader': value.isHeader,
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const RichTextTableRowNodeTypeEnum = {
    TABLE_ROW: 'TABLE_ROW'
};
/**
 * Check if a given object implements the RichTextTableRowNode interface.
 */
function instanceOfRichTextTableRowNode(value) {
    let isInstance = true;
    isInstance = isInstance && "children" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function RichTextTableRowNodeFromJSON(json) {
    return RichTextTableRowNodeFromJSONTyped(json);
}
function RichTextTableRowNodeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'children': (json['children'].map(RichTextTableCellNodeFromJSON)),
        'type': json['type'],
    };
}
function RichTextTableRowNodeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'children': (value.children.map(RichTextTableCellNodeToJSON)),
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const RichTextTableNodeTypeEnum = {
    TABLE: 'TABLE'
};
/**
 * Check if a given object implements the RichTextTableNode interface.
 */
function instanceOfRichTextTableNode(value) {
    let isInstance = true;
    isInstance = isInstance && "children" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function RichTextTableNodeFromJSON(json) {
    return RichTextTableNodeFromJSONTyped(json);
}
function RichTextTableNodeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'children': (json['children'].map(RichTextTableRowNodeFromJSON)),
        'type': json['type'],
    };
}
function RichTextTableNodeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'children': (value.children.map(RichTextTableRowNodeToJSON)),
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function isRichTextDataFieldNode(value) {
    return value.type === "DATA_FIELD";
}
function isRichTextLineBreakNode(value) {
    return value.type === "LINE_BREAK";
}
function isRichTextLinkNode(value) {
    return value.type === "LINK";
}
function isRichTextListNode(value) {
    return value.type === "LIST";
}
function isRichTextListItemNode(value) {
    return value.type === "LIST_ITEM";
}
function isRichTextParagraphNode(value) {
    return value.type === "PARAGRAPH";
}
function isRichTextRootNode(value) {
    return value.type === "ROOT";
}
function isRichTextTableNode(value) {
    return value.type === "TABLE";
}
function isRichTextTableCellNode(value) {
    return value.type === "TABLE_CELL";
}
function isRichTextTableRowNode(value) {
    return value.type === "TABLE_ROW";
}
function isRichTextTextNode(value) {
    return value.type === "TEXT";
}
function RichTextNodeFromJSON(json) {
    return RichTextNodeFromJSONTyped(json);
}
function RichTextNodeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['type']) {
        case 'DATA_FIELD':
            return Object.assign(Object.assign({}, RichTextDataFieldNodeFromJSONTyped(json)), { type: 'DATA_FIELD' });
        case 'LINE_BREAK':
            return Object.assign(Object.assign({}, RichTextLineBreakNodeFromJSONTyped(json)), { type: 'LINE_BREAK' });
        case 'LINK':
            return Object.assign(Object.assign({}, RichTextLinkNodeFromJSONTyped(json)), { type: 'LINK' });
        case 'LIST':
            return Object.assign(Object.assign({}, RichTextListNodeFromJSONTyped(json)), { type: 'LIST' });
        case 'LIST_ITEM':
            return Object.assign(Object.assign({}, RichTextListItemNodeFromJSONTyped(json)), { type: 'LIST_ITEM' });
        case 'PARAGRAPH':
            return Object.assign(Object.assign({}, RichTextParagraphNodeFromJSONTyped(json)), { type: 'PARAGRAPH' });
        case 'ROOT':
            return Object.assign(Object.assign({}, RichTextRootNodeFromJSONTyped(json)), { type: 'ROOT' });
        case 'TABLE':
            return Object.assign(Object.assign({}, RichTextTableNodeFromJSONTyped(json)), { type: 'TABLE' });
        case 'TABLE_CELL':
            return Object.assign(Object.assign({}, RichTextTableCellNodeFromJSONTyped(json)), { type: 'TABLE_CELL' });
        case 'TABLE_ROW':
            return Object.assign(Object.assign({}, RichTextTableRowNodeFromJSONTyped(json)), { type: 'TABLE_ROW' });
        case 'TEXT':
            return Object.assign(Object.assign({}, RichTextTextNodeFromJSONTyped(json)), { type: 'TEXT' });
        default:
            throw new Error(`No variant of RichTextNode exists with 'type=${json['type']}'`);
    }
}
function RichTextNodeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['type']) {
        case 'DATA_FIELD':
            return RichTextDataFieldNodeToJSON(value);
        case 'LINE_BREAK':
            return RichTextLineBreakNodeToJSON(value);
        case 'LINK':
            return RichTextLinkNodeToJSON(value);
        case 'LIST':
            return RichTextListNodeToJSON(value);
        case 'LIST_ITEM':
            return RichTextListItemNodeToJSON(value);
        case 'PARAGRAPH':
            return RichTextParagraphNodeToJSON(value);
        case 'ROOT':
            return RichTextRootNodeToJSON(value);
        case 'TABLE':
            return RichTextTableNodeToJSON(value);
        case 'TABLE_CELL':
            return RichTextTableCellNodeToJSON(value);
        case 'TABLE_ROW':
            return RichTextTableRowNodeToJSON(value);
        case 'TEXT':
            return RichTextTextNodeToJSON(value);
        default:
            throw new Error(`No variant of RichTextNode exists with 'type=${value['type']}'`);
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const RichTextDataValueTypeEnum = {
    RICH_TEXT: 'RICH_TEXT'
};
/**
 * Check if a given object implements the RichTextDataValue interface.
 */
function instanceOfRichTextDataValue(value) {
    let isInstance = true;
    isInstance = isInstance && "text" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function RichTextDataValueFromJSON(json) {
    return RichTextDataValueFromJSONTyped(json);
}
function RichTextDataValueFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'text': RichTextNodeFromJSON(json['text']),
        'type': json['type'],
    };
}
function RichTextDataValueToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'text': RichTextNodeToJSON(value.text),
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const StringDataValueTypeEnum = {
    STRING: 'STRING'
};
/**
 * Check if a given object implements the StringDataValue interface.
 */
function instanceOfStringDataValue(value) {
    let isInstance = true;
    isInstance = isInstance && "text" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function StringDataValueFromJSON(json) {
    return StringDataValueFromJSONTyped(json);
}
function StringDataValueFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'text': json['text'],
        'type': json['type'],
    };
}
function StringDataValueToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'text': value.text,
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function isBooleanDataValue(value) {
    return value.type === "BOOLEAN";
}
function isDateDataValue(value) {
    return value.type === "DATE";
}
function isFileDataValue(value) {
    return value.type === "FILE";
}
function isNumberDataValue(value) {
    return value.type === "NUMBER";
}
function isRichTextDataValue(value) {
    return value.type === "RICH_TEXT";
}
function isStringDataValue(value) {
    return value.type === "STRING";
}
function DataValueFromJSON(json) {
    return DataValueFromJSONTyped(json);
}
function DataValueFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['type']) {
        case 'BOOLEAN':
            return Object.assign(Object.assign({}, BooleanDataValueFromJSONTyped(json)), { type: 'BOOLEAN' });
        case 'DATE':
            return Object.assign(Object.assign({}, DateDataValueFromJSONTyped(json)), { type: 'DATE' });
        case 'FILE':
            return Object.assign(Object.assign({}, FileDataValueFromJSONTyped(json)), { type: 'FILE' });
        case 'NUMBER':
            return Object.assign(Object.assign({}, NumberDataValueFromJSONTyped(json)), { type: 'NUMBER' });
        case 'RICH_TEXT':
            return Object.assign(Object.assign({}, RichTextDataValueFromJSONTyped(json)), { type: 'RICH_TEXT' });
        case 'STRING':
            return Object.assign(Object.assign({}, StringDataValueFromJSONTyped(json)), { type: 'STRING' });
        default:
            throw new Error(`No variant of DataValue exists with 'type=${json['type']}'`);
    }
}
function DataValueToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['type']) {
        case 'BOOLEAN':
            return BooleanDataValueToJSON(value);
        case 'DATE':
            return DateDataValueToJSON(value);
        case 'FILE':
            return FileDataValueToJSON(value);
        case 'NUMBER':
            return NumberDataValueToJSON(value);
        case 'RICH_TEXT':
            return RichTextDataValueToJSON(value);
        case 'STRING':
            return StringDataValueToJSON(value);
        default:
            throw new Error(`No variant of DataValue exists with 'type=${value['type']}'`);
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const ValueDataNodeTypeEnum = {
    VALUE: 'VALUE'
};
/**
 * Check if a given object implements the ValueDataNode interface.
 */
function instanceOfValueDataNode(value) {
    let isInstance = true;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "value" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function ValueDataNodeFromJSON(json) {
    return ValueDataNodeFromJSONTyped(json);
}
function ValueDataNodeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'description': !exists(json, 'description') ? undefined : json['description'],
        'label': json['label'],
        'value': DataValueFromJSON(json['value']),
        'type': json['type'],
    };
}
function ValueDataNodeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'description': value.description,
        'label': value.label,
        'value': DataValueToJSON(value.value),
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function isContainerDataNode(value) {
    return value.type === "CONTAINER";
}
function isValueDataNode(value) {
    return value.type === "VALUE";
}
function DataNodeFromJSON(json) {
    return DataNodeFromJSONTyped(json);
}
function DataNodeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['type']) {
        case 'CONTAINER':
            return Object.assign(Object.assign({}, ContainerDataNodeFromJSONTyped(json)), { type: 'CONTAINER' });
        case 'VALUE':
            return Object.assign(Object.assign({}, ValueDataNodeFromJSONTyped(json)), { type: 'VALUE' });
        default:
            throw new Error(`No variant of DataNode exists with 'type=${json['type']}'`);
    }
}
function DataNodeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['type']) {
        case 'CONTAINER':
            return ContainerDataNodeToJSON(value);
        case 'VALUE':
            return ValueDataNodeToJSON(value);
        default:
            throw new Error(`No variant of DataNode exists with 'type=${value['type']}'`);
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const ContainerDataNodeTypeEnum = {
    CONTAINER: 'CONTAINER'
};
/**
 * Check if a given object implements the ContainerDataNode interface.
 */
function instanceOfContainerDataNode(value) {
    let isInstance = true;
    isInstance = isInstance && "children" in value;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function ContainerDataNodeFromJSON(json) {
    return ContainerDataNodeFromJSONTyped(json);
}
function ContainerDataNodeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'children': (json['children'].map(DataNodeFromJSON)),
        'label': json['label'],
        'type': json['type'],
    };
}
function ContainerDataNodeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'children': (value.children.map(DataNodeToJSON)),
        'label': value.label,
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CustomAttributeValue interface.
 */
function instanceOfCustomAttributeValue(value) {
    let isInstance = true;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "valueType" in value;
    return isInstance;
}
function CustomAttributeValueFromJSON(json) {
    return CustomAttributeValueFromJSONTyped(json);
}
function CustomAttributeValueFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'label': json['label'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'valueType': AttributeValueTypeFromJSON(json['valueType']),
    };
}
function CustomAttributeValueToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'label': value.label,
        'value': value.value,
        'valueType': AttributeValueTypeToJSON(value.valueType),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const DataFieldConstraintViolationExecutionErrorTypeEnum = {
    DATA_FIELD_CONSTRAINT_VIOLATION: 'DATA_FIELD_CONSTRAINT_VIOLATION'
};
/**
 * Check if a given object implements the DataFieldConstraintViolationExecutionError interface.
 */
function instanceOfDataFieldConstraintViolationExecutionError(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function DataFieldConstraintViolationExecutionErrorFromJSON(json) {
    return DataFieldConstraintViolationExecutionErrorFromJSONTyped(json);
}
function DataFieldConstraintViolationExecutionErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fieldId': !exists(json, 'fieldId') ? undefined : json['fieldId'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'value': !exists(json, 'value') ? undefined : DataValueFromJSON(json['value']),
        'type': json['type'],
    };
}
function DataFieldConstraintViolationExecutionErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fieldId': value.fieldId,
        'message': value.message,
        'value': DataValueToJSON(value.value),
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
const DataFieldType = {
    BOOLEAN: 'BOOLEAN',
    STRING: 'STRING',
    NUMBER: 'NUMBER',
    DATE: 'DATE',
    FILE: 'FILE'
};
function DataFieldTypeFromJSON(json) {
    return DataFieldTypeFromJSONTyped(json);
}
function DataFieldTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function DataFieldTypeToJSON(value) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DataFieldOutline interface.
 */
function instanceOfDataFieldOutline(value) {
    let isInstance = true;
    isInstance = isInstance && "isRequired" in value;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "path" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function DataFieldOutlineFromJSON(json) {
    return DataFieldOutlineFromJSONTyped(json);
}
function DataFieldOutlineFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'description': !exists(json, 'description') ? undefined : json['description'],
        'isRequired': json['isRequired'],
        'label': json['label'],
        'path': json['path'],
        'type': DataFieldTypeFromJSON(json['type']),
    };
}
function DataFieldOutlineToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'description': value.description,
        'isRequired': value.isRequired,
        'label': value.label,
        'path': value.path,
        'type': DataFieldTypeToJSON(value.type),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
const DataNodeType = {
    ROOT: 'ROOT',
    CONTAINER: 'CONTAINER',
    VALUE: 'VALUE'
};
function DataNodeTypeFromJSON(json) {
    return DataNodeTypeFromJSONTyped(json);
}
function DataNodeTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function DataNodeTypeToJSON(value) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DateDataValueAllOf interface.
 */
function instanceOfDateDataValueAllOf(value) {
    let isInstance = true;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function DateDataValueAllOfFromJSON(json) {
    return DateDataValueAllOfFromJSONTyped(json);
}
function DateDataValueAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'date': json['date'],
        'type': DataValueTypeFromJSON(json['type']),
    };
}
function DateDataValueAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'date': value.date,
        'type': DataValueTypeToJSON(value.type),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const DateDataValueAllOf1TypeEnum = {
    DATE: 'DATE'
};
/**
 * Check if a given object implements the DateDataValueAllOf1 interface.
 */
function instanceOfDateDataValueAllOf1(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function DateDataValueAllOf1FromJSON(json) {
    return DateDataValueAllOf1FromJSONTyped(json);
}
function DateDataValueAllOf1FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': json['type'],
    };
}
function DateDataValueAllOf1ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const DateNodeInputTypeEnum = {
    DATE: 'DATE'
};
/**
 * Check if a given object implements the DateNodeInput interface.
 */
function instanceOfDateNodeInput(value) {
    let isInstance = true;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function DateNodeInputFromJSON(json) {
    return DateNodeInputFromJSONTyped(json);
}
function DateNodeInputFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'date': json['date'],
        'type': json['type'],
    };
}
function DateNodeInputToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'date': value.date,
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const DynamicChoiceNodeInputTypeEnum = {
    DYNAMIC_CHOICE: 'DYNAMIC_CHOICE'
};
/**
 * Check if a given object implements the DynamicChoiceNodeInput interface.
 */
function instanceOfDynamicChoiceNodeInput(value) {
    let isInstance = true;
    isInstance = isInstance && "key" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function DynamicChoiceNodeInputFromJSON(json) {
    return DynamicChoiceNodeInputFromJSONTyped(json);
}
function DynamicChoiceNodeInputFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'key': json['key'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'type': json['type'],
    };
}
function DynamicChoiceNodeInputToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'key': value.key,
        'label': value.label,
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const EmptyNodeInputTypeEnum = {
    EMPTY: 'EMPTY'
};
/**
 * Check if a given object implements the EmptyNodeInput interface.
 */
function instanceOfEmptyNodeInput(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function EmptyNodeInputFromJSON(json) {
    return EmptyNodeInputFromJSONTyped(json);
}
function EmptyNodeInputFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': json['type'],
    };
}
function EmptyNodeInputToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const InputFieldsMissingExecutionErrorTypeEnum = {
    INPUT_FIELDS_MISSING: 'INPUT_FIELDS_MISSING'
};
/**
 * Check if a given object implements the InputFieldsMissingExecutionError interface.
 */
function instanceOfInputFieldsMissingExecutionError(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function InputFieldsMissingExecutionErrorFromJSON(json) {
    return InputFieldsMissingExecutionErrorFromJSONTyped(json);
}
function InputFieldsMissingExecutionErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nodeId': !exists(json, 'nodeId') ? undefined : json['nodeId'],
        'type': json['type'],
    };
}
function InputFieldsMissingExecutionErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nodeId': value.nodeId,
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const InternalExecutionErrorTypeEnum = {
    INTERNAL_ERROR: 'INTERNAL_ERROR'
};
/**
 * Check if a given object implements the InternalExecutionError interface.
 */
function instanceOfInternalExecutionError(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function InternalExecutionErrorFromJSON(json) {
    return InternalExecutionErrorFromJSONTyped(json);
}
function InternalExecutionErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
        'type': json['type'],
    };
}
function InternalExecutionErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'errorMessage': value.errorMessage,
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const LogicScriptFailedCompilationExecutionErrorTypeEnum = {
    LOGIC_SCRIPT_COMPILATION_ERROR: 'LOGIC_SCRIPT_COMPILATION_ERROR'
};
/**
 * Check if a given object implements the LogicScriptFailedCompilationExecutionError interface.
 */
function instanceOfLogicScriptFailedCompilationExecutionError(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function LogicScriptFailedCompilationExecutionErrorFromJSON(json) {
    return LogicScriptFailedCompilationExecutionErrorFromJSONTyped(json);
}
function LogicScriptFailedCompilationExecutionErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'compilationErrors': !exists(json, 'compilationErrors') ? undefined : json['compilationErrors'],
        'type': json['type'],
    };
}
function LogicScriptFailedCompilationExecutionErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'compilationErrors': value.compilationErrors,
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const LogicScriptFailedRuntimeExecutionErrorTypeEnum = {
    LOGIC_SCRIPT_RUNTIME_ERROR: 'LOGIC_SCRIPT_RUNTIME_ERROR'
};
/**
 * Check if a given object implements the LogicScriptFailedRuntimeExecutionError interface.
 */
function instanceOfLogicScriptFailedRuntimeExecutionError(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function LogicScriptFailedRuntimeExecutionErrorFromJSON(json) {
    return LogicScriptFailedRuntimeExecutionErrorFromJSONTyped(json);
}
function LogicScriptFailedRuntimeExecutionErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'runtimeError': !exists(json, 'runtimeError') ? undefined : json['runtimeError'],
        'type': json['type'],
    };
}
function LogicScriptFailedRuntimeExecutionErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'runtimeError': value.runtimeError,
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const LogicScriptFailedTimeoutExecutionErrorTypeEnum = {
    LOGIC_SCRIPT_TIMEOUT_ERROR: 'LOGIC_SCRIPT_TIMEOUT_ERROR'
};
/**
 * Check if a given object implements the LogicScriptFailedTimeoutExecutionError interface.
 */
function instanceOfLogicScriptFailedTimeoutExecutionError(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function LogicScriptFailedTimeoutExecutionErrorFromJSON(json) {
    return LogicScriptFailedTimeoutExecutionErrorFromJSONTyped(json);
}
function LogicScriptFailedTimeoutExecutionErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': json['type'],
    };
}
function LogicScriptFailedTimeoutExecutionErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const LogicScriptMissingValueExecutionErrorTypeEnum = {
    LOGIC_SCRIPT_MISSING_VALUE: 'LOGIC_SCRIPT_MISSING_VALUE'
};
/**
 * Check if a given object implements the LogicScriptMissingValueExecutionError interface.
 */
function instanceOfLogicScriptMissingValueExecutionError(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function LogicScriptMissingValueExecutionErrorFromJSON(json) {
    return LogicScriptMissingValueExecutionErrorFromJSONTyped(json);
}
function LogicScriptMissingValueExecutionErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'usedUnsetFieldIds': !exists(json, 'usedUnsetFieldIds') ? undefined : json['usedUnsetFieldIds'],
        'type': json['type'],
    };
}
function LogicScriptMissingValueExecutionErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'usedUnsetFieldIds': value.usedUnsetFieldIds,
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ModelSignature interface.
 */
function instanceOfModelSignature(value) {
    let isInstance = true;
    return isInstance;
}
function ModelSignatureFromJSON(json) {
    return ModelSignatureFromJSONTyped(json);
}
function ModelSignatureFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'modelId': !exists(json, 'modelId') ? undefined : json['modelId'],
        'version': !exists(json, 'version') ? undefined : json['version'],
    };
}
function ModelSignatureToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'modelId': value.modelId,
        'version': value.version,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const ModelNotFoundExecutionErrorTypeEnum = {
    MODEL_NOT_FOUND: 'MODEL_NOT_FOUND'
};
/**
 * Check if a given object implements the ModelNotFoundExecutionError interface.
 */
function instanceOfModelNotFoundExecutionError(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function ModelNotFoundExecutionErrorFromJSON(json) {
    return ModelNotFoundExecutionErrorFromJSONTyped(json);
}
function ModelNotFoundExecutionErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'model': !exists(json, 'model') ? undefined : ModelSignatureFromJSON(json['model']),
        'type': json['type'],
    };
}
function ModelNotFoundExecutionErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'model': ModelSignatureToJSON(value.model),
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function isApiExchangeMissingExecutionError(value) {
    return value.type === "API_EXCHANGE_MISSING";
}
function isDataFieldConstraintViolationExecutionError(value) {
    return value.type === "DATA_FIELD_CONSTRAINT_VIOLATION";
}
function isInputFieldsMissingExecutionError(value) {
    return value.type === "INPUT_FIELDS_MISSING";
}
function isInternalExecutionError(value) {
    return value.type === "INTERNAL_ERROR";
}
function isLogicScriptFailedCompilationExecutionError(value) {
    return value.type === "LOGIC_SCRIPT_COMPILATION_ERROR";
}
function isLogicScriptMissingValueExecutionError(value) {
    return value.type === "LOGIC_SCRIPT_MISSING_VALUE";
}
function isLogicScriptFailedRuntimeExecutionError(value) {
    return value.type === "LOGIC_SCRIPT_RUNTIME_ERROR";
}
function isLogicScriptFailedTimeoutExecutionError(value) {
    return value.type === "LOGIC_SCRIPT_TIMEOUT_ERROR";
}
function isModelNotFoundExecutionError(value) {
    return value.type === "MODEL_NOT_FOUND";
}
function ExecutionErrorFromJSON(json) {
    return ExecutionErrorFromJSONTyped(json);
}
function ExecutionErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['type']) {
        case 'API_EXCHANGE_MISSING':
            return Object.assign(Object.assign({}, ApiExchangeMissingExecutionErrorFromJSONTyped(json)), { type: 'API_EXCHANGE_MISSING' });
        case 'DATA_FIELD_CONSTRAINT_VIOLATION':
            return Object.assign(Object.assign({}, DataFieldConstraintViolationExecutionErrorFromJSONTyped(json)), { type: 'DATA_FIELD_CONSTRAINT_VIOLATION' });
        case 'INPUT_FIELDS_MISSING':
            return Object.assign(Object.assign({}, InputFieldsMissingExecutionErrorFromJSONTyped(json)), { type: 'INPUT_FIELDS_MISSING' });
        case 'INTERNAL_ERROR':
            return Object.assign(Object.assign({}, InternalExecutionErrorFromJSONTyped(json)), { type: 'INTERNAL_ERROR' });
        case 'LOGIC_SCRIPT_COMPILATION_ERROR':
            return Object.assign(Object.assign({}, LogicScriptFailedCompilationExecutionErrorFromJSONTyped(json)), { type: 'LOGIC_SCRIPT_COMPILATION_ERROR' });
        case 'LOGIC_SCRIPT_MISSING_VALUE':
            return Object.assign(Object.assign({}, LogicScriptMissingValueExecutionErrorFromJSONTyped(json)), { type: 'LOGIC_SCRIPT_MISSING_VALUE' });
        case 'LOGIC_SCRIPT_RUNTIME_ERROR':
            return Object.assign(Object.assign({}, LogicScriptFailedRuntimeExecutionErrorFromJSONTyped(json)), { type: 'LOGIC_SCRIPT_RUNTIME_ERROR' });
        case 'LOGIC_SCRIPT_TIMEOUT_ERROR':
            return Object.assign(Object.assign({}, LogicScriptFailedTimeoutExecutionErrorFromJSONTyped(json)), { type: 'LOGIC_SCRIPT_TIMEOUT_ERROR' });
        case 'MODEL_NOT_FOUND':
            return Object.assign(Object.assign({}, ModelNotFoundExecutionErrorFromJSONTyped(json)), { type: 'MODEL_NOT_FOUND' });
        default:
            throw new Error(`No variant of ExecutionError exists with 'type=${json['type']}'`);
    }
}
function ExecutionErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['type']) {
        case 'API_EXCHANGE_MISSING':
            return ApiExchangeMissingExecutionErrorToJSON(value);
        case 'DATA_FIELD_CONSTRAINT_VIOLATION':
            return DataFieldConstraintViolationExecutionErrorToJSON(value);
        case 'INPUT_FIELDS_MISSING':
            return InputFieldsMissingExecutionErrorToJSON(value);
        case 'INTERNAL_ERROR':
            return InternalExecutionErrorToJSON(value);
        case 'LOGIC_SCRIPT_COMPILATION_ERROR':
            return LogicScriptFailedCompilationExecutionErrorToJSON(value);
        case 'LOGIC_SCRIPT_MISSING_VALUE':
            return LogicScriptMissingValueExecutionErrorToJSON(value);
        case 'LOGIC_SCRIPT_RUNTIME_ERROR':
            return LogicScriptFailedRuntimeExecutionErrorToJSON(value);
        case 'LOGIC_SCRIPT_TIMEOUT_ERROR':
            return LogicScriptFailedTimeoutExecutionErrorToJSON(value);
        case 'MODEL_NOT_FOUND':
            return ModelNotFoundExecutionErrorToJSON(value);
        default:
            throw new Error(`No variant of ExecutionError exists with 'type=${value['type']}'`);
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ErrorExecutionResult interface.
 */
function instanceOfErrorExecutionResult(value) {
    let isInstance = true;
    return isInstance;
}
function ErrorExecutionResultFromJSON(json) {
    return ErrorExecutionResultFromJSONTyped(json);
}
function ErrorExecutionResultFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'error': !exists(json, 'error') ? undefined : ExecutionErrorFromJSON(json['error']),
        'nodeId': !exists(json, 'nodeId') ? undefined : json['nodeId'],
    };
}
function ErrorExecutionResultToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'error': ExecutionErrorToJSON(value.error),
        'nodeId': value.nodeId,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the EvaluatedDataTableField interface.
 */
function instanceOfEvaluatedDataTableField(value) {
    let isInstance = true;
    isInstance = isInstance && "index" in value;
    return isInstance;
}
function EvaluatedDataTableFieldFromJSON(json) {
    return EvaluatedDataTableFieldFromJSONTyped(json);
}
function EvaluatedDataTableFieldFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'index': json['index'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'link': !exists(json, 'link') ? undefined : json['link'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}
function EvaluatedDataTableFieldToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'index': value.index,
        'label': value.label,
        'link': value.link,
        'value': value.value,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const EvaluatedDataTableTypeEnum = {
    TABLE: 'TABLE'
};
/**
 * Check if a given object implements the EvaluatedDataTable interface.
 */
function instanceOfEvaluatedDataTable(value) {
    let isInstance = true;
    isInstance = isInstance && "fields" in value;
    isInstance = isInstance && "index" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function EvaluatedDataTableFromJSON(json) {
    return EvaluatedDataTableFromJSONTyped(json);
}
function EvaluatedDataTableFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fields': (json['fields'].map(EvaluatedDataTableFieldFromJSON)),
        'index': json['index'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'type': json['type'],
    };
}
function EvaluatedDataTableToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fields': (value.fields.map(EvaluatedDataTableFieldToJSON)),
        'index': value.index,
        'title': value.title,
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const EvaluatedReportTypeEnum = {
    REPORT: 'REPORT'
};
/**
 * Check if a given object implements the EvaluatedReport interface.
 */
function instanceOfEvaluatedReport(value) {
    let isInstance = true;
    isInstance = isInstance && "index" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function EvaluatedReportFromJSON(json) {
    return EvaluatedReportFromJSONTyped(json);
}
function EvaluatedReportFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'index': json['index'],
        'report': !exists(json, 'report') ? undefined : json['report'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'type': json['type'],
    };
}
function EvaluatedReportToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'index': value.index,
        'report': value.report,
        'title': value.title,
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function isEvaluatedReport(value) {
    return value.type === "REPORT";
}
function isEvaluatedDataTable(value) {
    return value.type === "TABLE";
}
function EvaluatedSectionFromJSON(json) {
    return EvaluatedSectionFromJSONTyped(json);
}
function EvaluatedSectionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['type']) {
        case 'REPORT':
            return Object.assign(Object.assign({}, EvaluatedReportFromJSONTyped(json)), { type: 'REPORT' });
        case 'TABLE':
            return Object.assign(Object.assign({}, EvaluatedDataTableFromJSONTyped(json)), { type: 'TABLE' });
        default:
            throw new Error(`No variant of EvaluatedSection exists with 'type=${json['type']}'`);
    }
}
function EvaluatedSectionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['type']) {
        case 'REPORT':
            return EvaluatedReportToJSON(value);
        case 'TABLE':
            return EvaluatedDataTableToJSON(value);
        default:
            throw new Error(`No variant of EvaluatedSection exists with 'type=${value['type']}'`);
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the EvaluatedSections interface.
 */
function instanceOfEvaluatedSections(value) {
    let isInstance = true;
    isInstance = isInstance && "sections" in value;
    return isInstance;
}
function EvaluatedSectionsFromJSON(json) {
    return EvaluatedSectionsFromJSONTyped(json);
}
function EvaluatedSectionsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'date': !exists(json, 'date') ? undefined : json['date'],
        'sections': (json['sections'].map(EvaluatedSectionFromJSON)),
        'statusLong': !exists(json, 'statusLong') ? undefined : json['statusLong'],
        'statusShort': !exists(json, 'statusShort') ? undefined : json['statusShort'],
        'title': !exists(json, 'title') ? undefined : json['title'],
    };
}
function EvaluatedSectionsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'date': value.date,
        'sections': (value.sections.map(EvaluatedSectionToJSON)),
        'statusLong': value.statusLong,
        'statusShort': value.statusShort,
        'title': value.title,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FileDataValueAllOf interface.
 */
function instanceOfFileDataValueAllOf(value) {
    let isInstance = true;
    isInstance = isInstance && "file" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function FileDataValueAllOfFromJSON(json) {
    return FileDataValueAllOfFromJSONTyped(json);
}
function FileDataValueAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'file': KNSFileFromJSON(json['file']),
        'type': DataValueTypeFromJSON(json['type']),
    };
}
function FileDataValueAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'file': KNSFileToJSON(value.file),
        'type': DataValueTypeToJSON(value.type),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const FileDataValueAllOf1TypeEnum = {
    FILE: 'FILE'
};
/**
 * Check if a given object implements the FileDataValueAllOf1 interface.
 */
function instanceOfFileDataValueAllOf1(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function FileDataValueAllOf1FromJSON(json) {
    return FileDataValueAllOf1FromJSONTyped(json);
}
function FileDataValueAllOf1FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': json['type'],
    };
}
function FileDataValueAllOf1ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const FileNodeInputTypeEnum = {
    FILE: 'FILE'
};
/**
 * Check if a given object implements the FileNodeInput interface.
 */
function instanceOfFileNodeInput(value) {
    let isInstance = true;
    isInstance = isInstance && "file" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function FileNodeInputFromJSON(json) {
    return FileNodeInputFromJSONTyped(json);
}
function FileNodeInputFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'file': KNSFileFromJSON(json['file']),
        'type': json['type'],
    };
}
function FileNodeInputToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'file': KNSFileToJSON(value.file),
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FileResponse interface.
 */
function instanceOfFileResponse(value) {
    let isInstance = true;
    isInstance = isInstance && "file" in value;
    return isInstance;
}
function FileResponseFromJSON(json) {
    return FileResponseFromJSONTyped(json);
}
function FileResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'file': KNSFileFromJSON(json['file']),
    };
}
function FileResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'file': KNSFileToJSON(value.file),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FontConfig interface.
 */
function instanceOfFontConfig(value) {
    let isInstance = true;
    return isInstance;
}
function FontConfigFromJSON(json) {
    return FontConfigFromJSONTyped(json);
}
function FontConfigFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fontFamily': !exists(json, 'fontFamily') ? undefined : json['fontFamily'],
        'fontUrl': !exists(json, 'fontUrl') ? undefined : json['fontUrl'],
    };
}
function FontConfigToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fontFamily': value.fontFamily,
        'fontUrl': value.fontUrl,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the GetModelInterfaceRequest interface.
 */
function instanceOfGetModelInterfaceRequest(value) {
    let isInstance = true;
    isInstance = isInstance && "modelId" in value;
    return isInstance;
}
function GetModelInterfaceRequestFromJSON(json) {
    return GetModelInterfaceRequestFromJSONTyped(json);
}
function GetModelInterfaceRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'modelId': json['modelId'],
        'version': !exists(json, 'version') ? undefined : json['version'],
    };
}
function GetModelInterfaceRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'modelId': value.modelId,
        'version': value.version,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const MultipleChoiceNodeInputTypeEnum = {
    MULTIPLE_CHOICE: 'MULTIPLE_CHOICE'
};
/**
 * Check if a given object implements the MultipleChoiceNodeInput interface.
 */
function instanceOfMultipleChoiceNodeInput(value) {
    let isInstance = true;
    isInstance = isInstance && "selectedOptionIds" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function MultipleChoiceNodeInputFromJSON(json) {
    return MultipleChoiceNodeInputFromJSONTyped(json);
}
function MultipleChoiceNodeInputFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'selectedOptionIds': json['selectedOptionIds'],
        'type': json['type'],
    };
}
function MultipleChoiceNodeInputToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'selectedOptionIds': value.selectedOptionIds,
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const NumberNodeInputTypeEnum = {
    NUMBER: 'NUMBER'
};
/**
 * Check if a given object implements the NumberNodeInput interface.
 */
function instanceOfNumberNodeInput(value) {
    let isInstance = true;
    isInstance = isInstance && "number" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function NumberNodeInputFromJSON(json) {
    return NumberNodeInputFromJSONTyped(json);
}
function NumberNodeInputFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'number': json['number'],
        'type': json['type'],
    };
}
function NumberNodeInputToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'number': value.number,
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const SingleChoiceNodeInputTypeEnum = {
    SINGLE_CHOICE: 'SINGLE_CHOICE'
};
/**
 * Check if a given object implements the SingleChoiceNodeInput interface.
 */
function instanceOfSingleChoiceNodeInput(value) {
    let isInstance = true;
    isInstance = isInstance && "optionId" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function SingleChoiceNodeInputFromJSON(json) {
    return SingleChoiceNodeInputFromJSONTyped(json);
}
function SingleChoiceNodeInputFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'optionId': json['optionId'],
        'type': json['type'],
    };
}
function SingleChoiceNodeInputToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'optionId': value.optionId,
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const TextNodeInputTypeEnum = {
    TEXT: 'TEXT'
};
/**
 * Check if a given object implements the TextNodeInput interface.
 */
function instanceOfTextNodeInput(value) {
    let isInstance = true;
    isInstance = isInstance && "text" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function TextNodeInputFromJSON(json) {
    return TextNodeInputFromJSONTyped(json);
}
function TextNodeInputFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'text': json['text'],
        'type': json['type'],
    };
}
function TextNodeInputToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'text': value.text,
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function isBooleanNodeInput(value) {
    return value.type === "BOOLEAN";
}
function isDateNodeInput(value) {
    return value.type === "DATE";
}
function isDynamicChoiceNodeInput(value) {
    return value.type === "DYNAMIC_CHOICE";
}
function isEmptyNodeInput(value) {
    return value.type === "EMPTY";
}
function isFileNodeInput(value) {
    return value.type === "FILE";
}
function isMultipleChoiceNodeInput(value) {
    return value.type === "MULTIPLE_CHOICE";
}
function isNumberNodeInput(value) {
    return value.type === "NUMBER";
}
function isSingleChoiceNodeInput(value) {
    return value.type === "SINGLE_CHOICE";
}
function isTextNodeInput(value) {
    return value.type === "TEXT";
}
function NodeInputFromJSON(json) {
    return NodeInputFromJSONTyped(json);
}
function NodeInputFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['type']) {
        case 'BOOLEAN':
            return Object.assign(Object.assign({}, BooleanNodeInputFromJSONTyped(json)), { type: 'BOOLEAN' });
        case 'DATE':
            return Object.assign(Object.assign({}, DateNodeInputFromJSONTyped(json)), { type: 'DATE' });
        case 'DYNAMIC_CHOICE':
            return Object.assign(Object.assign({}, DynamicChoiceNodeInputFromJSONTyped(json)), { type: 'DYNAMIC_CHOICE' });
        case 'EMPTY':
            return Object.assign(Object.assign({}, EmptyNodeInputFromJSONTyped(json)), { type: 'EMPTY' });
        case 'FILE':
            return Object.assign(Object.assign({}, FileNodeInputFromJSONTyped(json)), { type: 'FILE' });
        case 'MULTIPLE_CHOICE':
            return Object.assign(Object.assign({}, MultipleChoiceNodeInputFromJSONTyped(json)), { type: 'MULTIPLE_CHOICE' });
        case 'NUMBER':
            return Object.assign(Object.assign({}, NumberNodeInputFromJSONTyped(json)), { type: 'NUMBER' });
        case 'SINGLE_CHOICE':
            return Object.assign(Object.assign({}, SingleChoiceNodeInputFromJSONTyped(json)), { type: 'SINGLE_CHOICE' });
        case 'TEXT':
            return Object.assign(Object.assign({}, TextNodeInputFromJSONTyped(json)), { type: 'TEXT' });
        default:
            throw new Error(`No variant of NodeInput exists with 'type=${json['type']}'`);
    }
}
function NodeInputToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['type']) {
        case 'BOOLEAN':
            return BooleanNodeInputToJSON(value);
        case 'DATE':
            return DateNodeInputToJSON(value);
        case 'DYNAMIC_CHOICE':
            return DynamicChoiceNodeInputToJSON(value);
        case 'EMPTY':
            return EmptyNodeInputToJSON(value);
        case 'FILE':
            return FileNodeInputToJSON(value);
        case 'MULTIPLE_CHOICE':
            return MultipleChoiceNodeInputToJSON(value);
        case 'NUMBER':
            return NumberNodeInputToJSON(value);
        case 'SINGLE_CHOICE':
            return SingleChoiceNodeInputToJSON(value);
        case 'TEXT':
            return TextNodeInputToJSON(value);
        default:
            throw new Error(`No variant of NodeInput exists with 'type=${value['type']}'`);
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const SystemChatMessageTypeEnum = {
    SYSTEM: 'SYSTEM'
};
/**
 * Check if a given object implements the SystemChatMessage interface.
 */
function instanceOfSystemChatMessage(value) {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function SystemChatMessageFromJSON(json) {
    return SystemChatMessageFromJSONTyped(json);
}
function SystemChatMessageFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'action': !exists(json, 'action') ? undefined : ChatActionOutlineFromJSON(json['action']),
        'message': json['message'],
        'type': json['type'],
    };
}
function SystemChatMessageToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'action': ChatActionOutlineToJSON(value.action),
        'message': value.message,
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const UserChatMessageTypeEnum = {
    USER: 'USER'
};
/**
 * Check if a given object implements the UserChatMessage interface.
 */
function instanceOfUserChatMessage(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function UserChatMessageFromJSON(json) {
    return UserChatMessageFromJSONTyped(json);
}
function UserChatMessageFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'actionLabel': !exists(json, 'actionLabel') ? undefined : json['actionLabel'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'type': json['type'],
    };
}
function UserChatMessageToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'actionLabel': value.actionLabel,
        'message': value.message,
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function isSystemChatMessage(value) {
    return value.type === "SYSTEM";
}
function isUserChatMessage(value) {
    return value.type === "USER";
}
function ChatMessageFromJSON(json) {
    return ChatMessageFromJSONTyped(json);
}
function ChatMessageFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['type']) {
        case 'SYSTEM':
            return Object.assign(Object.assign({}, SystemChatMessageFromJSONTyped(json)), { type: 'SYSTEM' });
        case 'USER':
            return Object.assign(Object.assign({}, UserChatMessageFromJSONTyped(json)), { type: 'USER' });
        default:
            throw new Error(`No variant of ChatMessage exists with 'type=${json['type']}'`);
    }
}
function ChatMessageToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['type']) {
        case 'SYSTEM':
            return SystemChatMessageToJSON(value);
        case 'USER':
            return UserChatMessageToJSON(value);
        default:
            throw new Error(`No variant of ChatMessage exists with 'type=${value['type']}'`);
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const ChatNodeNodeTypeEnum = {
    CHAT: 'CHAT'
};
/**
 * Check if a given object implements the ChatNode interface.
 */
function instanceOfChatNode(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "messages" in value;
    isInstance = isInstance && "nodeType" in value;
    return isInstance;
}
function ChatNodeFromJSON(json) {
    return ChatNodeFromJSONTyped(json);
}
function ChatNodeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'description': !exists(json, 'description') ? undefined : json['description'],
        'hasMedia': !exists(json, 'hasMedia') ? undefined : json['hasMedia'],
        'highlightedMedia': !exists(json, 'highlightedMedia') ? undefined : (json['highlightedMedia'].map(FileReferenceFromJSON)),
        'hint': !exists(json, 'hint') ? undefined : json['hint'],
        'id': json['id'],
        'instruction': !exists(json, 'instruction') ? undefined : json['instruction'],
        'introduction': !exists(json, 'introduction') ? undefined : json['introduction'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'mediaGallery': !exists(json, 'mediaGallery') ? undefined : (json['mediaGallery'].map(FileReferenceFromJSON)),
        'messages': (json['messages'].map(ChatMessageFromJSON)),
        'nodeType': json['nodeType'],
    };
}
function ChatNodeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'description': value.description,
        'highlightedMedia': value.highlightedMedia === undefined ? undefined : (value.highlightedMedia.map(FileReferenceToJSON)),
        'hint': value.hint,
        'id': value.id,
        'instruction': value.instruction,
        'introduction': value.introduction,
        'label': value.label,
        'mediaGallery': value.mediaGallery === undefined ? undefined : (value.mediaGallery.map(FileReferenceToJSON)),
        'messages': (value.messages.map(ChatMessageToJSON)),
        'nodeType': value.nodeType,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const DisplayNodeNodeTypeEnum = {
    PASSIVE: 'PASSIVE'
};
/**
 * Check if a given object implements the DisplayNode interface.
 */
function instanceOfDisplayNode(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "isEndNode" in value;
    isInstance = isInstance && "nodeType" in value;
    return isInstance;
}
function DisplayNodeFromJSON(json) {
    return DisplayNodeFromJSONTyped(json);
}
function DisplayNodeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'description': !exists(json, 'description') ? undefined : json['description'],
        'hasMedia': !exists(json, 'hasMedia') ? undefined : json['hasMedia'],
        'highlightedMedia': !exists(json, 'highlightedMedia') ? undefined : (json['highlightedMedia'].map(FileReferenceFromJSON)),
        'hint': !exists(json, 'hint') ? undefined : json['hint'],
        'id': json['id'],
        'instruction': !exists(json, 'instruction') ? undefined : json['instruction'],
        'introduction': !exists(json, 'introduction') ? undefined : json['introduction'],
        'isEndNode': json['isEndNode'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'mediaGallery': !exists(json, 'mediaGallery') ? undefined : (json['mediaGallery'].map(FileReferenceFromJSON)),
        'nodeType': json['nodeType'],
    };
}
function DisplayNodeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'description': value.description,
        'highlightedMedia': value.highlightedMedia === undefined ? undefined : (value.highlightedMedia.map(FileReferenceToJSON)),
        'hint': value.hint,
        'id': value.id,
        'instruction': value.instruction,
        'introduction': value.introduction,
        'isEndNode': value.isEndNode,
        'label': value.label,
        'mediaGallery': value.mediaGallery === undefined ? undefined : (value.mediaGallery.map(FileReferenceToJSON)),
        'nodeType': value.nodeType,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const BooleanInputFieldValueTypeEnum = {
    BOOLEAN: 'BOOLEAN'
};
/**
 * Check if a given object implements the BooleanInputField interface.
 */
function instanceOfBooleanInputField(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "required" in value;
    isInstance = isInstance && "valueType" in value;
    return isInstance;
}
function BooleanInputFieldFromJSON(json) {
    return BooleanInputFieldFromJSONTyped(json);
}
function BooleanInputFieldFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'annotation': !exists(json, 'annotation') ? undefined : json['annotation'],
        'displayType': !exists(json, 'displayType') ? undefined : BooleanDisplayTypeFromJSON(json['displayType']),
        'falseLabel': !exists(json, 'falseLabel') ? undefined : json['falseLabel'],
        'id': json['id'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'required': json['required'],
        'trueLabel': !exists(json, 'trueLabel') ? undefined : json['trueLabel'],
        'valueType': json['valueType'],
    };
}
function BooleanInputFieldToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'annotation': value.annotation,
        'displayType': BooleanDisplayTypeToJSON(value.displayType),
        'falseLabel': value.falseLabel,
        'id': value.id,
        'label': value.label,
        'required': value.required,
        'trueLabel': value.trueLabel,
        'valueType': value.valueType,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const DateInputFieldValueTypeEnum = {
    DATE: 'DATE'
};
/**
 * Check if a given object implements the DateInputField interface.
 */
function instanceOfDateInputField(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "required" in value;
    isInstance = isInstance && "valueType" in value;
    return isInstance;
}
function DateInputFieldFromJSON(json) {
    return DateInputFieldFromJSONTyped(json);
}
function DateInputFieldFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'annotation': !exists(json, 'annotation') ? undefined : json['annotation'],
        'id': json['id'],
        'includeTimeOfDay': !exists(json, 'includeTimeOfDay') ? undefined : json['includeTimeOfDay'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'maxDate': !exists(json, 'maxDate') ? undefined : json['maxDate'],
        'maxToday': !exists(json, 'maxToday') ? undefined : json['maxToday'],
        'minDate': !exists(json, 'minDate') ? undefined : json['minDate'],
        'minToday': !exists(json, 'minToday') ? undefined : json['minToday'],
        'required': json['required'],
        'valueType': json['valueType'],
    };
}
function DateInputFieldToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'annotation': value.annotation,
        'id': value.id,
        'includeTimeOfDay': value.includeTimeOfDay,
        'label': value.label,
        'maxDate': value.maxDate,
        'maxToday': value.maxToday,
        'minDate': value.minDate,
        'minToday': value.minToday,
        'required': value.required,
        'valueType': value.valueType,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const DynamicChoiceInputFieldValueTypeEnum = {
    DYNAMIC_CHOICE: 'DYNAMIC_CHOICE'
};
/**
 * Check if a given object implements the DynamicChoiceInputField interface.
 */
function instanceOfDynamicChoiceInputField(value) {
    let isInstance = true;
    isInstance = isInstance && "apiUrl" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "required" in value;
    isInstance = isInstance && "valueType" in value;
    return isInstance;
}
function DynamicChoiceInputFieldFromJSON(json) {
    return DynamicChoiceInputFieldFromJSONTyped(json);
}
function DynamicChoiceInputFieldFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'annotation': !exists(json, 'annotation') ? undefined : json['annotation'],
        'apiUrl': json['apiUrl'],
        'id': json['id'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'required': json['required'],
        'valueType': json['valueType'],
    };
}
function DynamicChoiceInputFieldToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'annotation': value.annotation,
        'apiUrl': value.apiUrl,
        'id': value.id,
        'label': value.label,
        'required': value.required,
        'valueType': value.valueType,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const FileInputFieldValueTypeEnum = {
    FILE: 'FILE'
};
/**
 * Check if a given object implements the FileInputField interface.
 */
function instanceOfFileInputField(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "required" in value;
    isInstance = isInstance && "valueType" in value;
    return isInstance;
}
function FileInputFieldFromJSON(json) {
    return FileInputFieldFromJSONTyped(json);
}
function FileInputFieldFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'allowedExtensions': !exists(json, 'allowedExtensions') ? undefined : json['allowedExtensions'],
        'annotation': !exists(json, 'annotation') ? undefined : json['annotation'],
        'id': json['id'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'required': json['required'],
        'valueType': json['valueType'],
    };
}
function FileInputFieldToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'allowedExtensions': value.allowedExtensions,
        'annotation': value.annotation,
        'id': value.id,
        'label': value.label,
        'required': value.required,
        'valueType': value.valueType,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const MultipleChoiceInputFieldValueTypeEnum = {
    MULTIPLE_CHOICE: 'MULTIPLE_CHOICE'
};
/**
 * Check if a given object implements the MultipleChoiceInputField interface.
 */
function instanceOfMultipleChoiceInputField(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "options" in value;
    isInstance = isInstance && "required" in value;
    isInstance = isInstance && "valueType" in value;
    return isInstance;
}
function MultipleChoiceInputFieldFromJSON(json) {
    return MultipleChoiceInputFieldFromJSONTyped(json);
}
function MultipleChoiceInputFieldFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'annotation': !exists(json, 'annotation') ? undefined : json['annotation'],
        'id': json['id'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'noneOption': !exists(json, 'noneOption') ? undefined : BaseChoiceFromJSON(json['noneOption']),
        'options': (json['options'].map(ChoiceFromJSON)),
        'required': json['required'],
        'valueType': json['valueType'],
    };
}
function MultipleChoiceInputFieldToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'annotation': value.annotation,
        'id': value.id,
        'label': value.label,
        'noneOption': BaseChoiceToJSON(value.noneOption),
        'options': (value.options.map(ChoiceToJSON)),
        'required': value.required,
        'valueType': value.valueType,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const NumberInputFieldValueTypeEnum = {
    NUMBER: 'NUMBER'
};
/**
 * Check if a given object implements the NumberInputField interface.
 */
function instanceOfNumberInputField(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "required" in value;
    isInstance = isInstance && "valueType" in value;
    return isInstance;
}
function NumberInputFieldFromJSON(json) {
    return NumberInputFieldFromJSONTyped(json);
}
function NumberInputFieldFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'annotation': !exists(json, 'annotation') ? undefined : json['annotation'],
        'id': json['id'],
        'integersOnly': !exists(json, 'integersOnly') ? undefined : json['integersOnly'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'maxValue': !exists(json, 'maxValue') ? undefined : json['maxValue'],
        'minValue': !exists(json, 'minValue') ? undefined : json['minValue'],
        'required': json['required'],
        'valueType': json['valueType'],
    };
}
function NumberInputFieldToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'annotation': value.annotation,
        'id': value.id,
        'integersOnly': value.integersOnly,
        'label': value.label,
        'maxValue': value.maxValue,
        'minValue': value.minValue,
        'required': value.required,
        'valueType': value.valueType,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
const SingleChoiceDisplayType = {
    RADIO_BUTTONS: 'RADIO_BUTTONS',
    DROPDOWN: 'DROPDOWN',
    AUTOCOMPLETE: 'AUTOCOMPLETE'
};
function SingleChoiceDisplayTypeFromJSON(json) {
    return SingleChoiceDisplayTypeFromJSONTyped(json);
}
function SingleChoiceDisplayTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function SingleChoiceDisplayTypeToJSON(value) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const SingleChoiceInputFieldValueTypeEnum = {
    SINGLE_CHOICE: 'SINGLE_CHOICE'
};
/**
 * Check if a given object implements the SingleChoiceInputField interface.
 */
function instanceOfSingleChoiceInputField(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "options" in value;
    isInstance = isInstance && "required" in value;
    isInstance = isInstance && "valueType" in value;
    return isInstance;
}
function SingleChoiceInputFieldFromJSON(json) {
    return SingleChoiceInputFieldFromJSONTyped(json);
}
function SingleChoiceInputFieldFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'annotation': !exists(json, 'annotation') ? undefined : json['annotation'],
        'displayType': !exists(json, 'displayType') ? undefined : SingleChoiceDisplayTypeFromJSON(json['displayType']),
        'id': json['id'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'options': (json['options'].map(ChoiceFromJSON)),
        'required': json['required'],
        'valueType': json['valueType'],
    };
}
function SingleChoiceInputFieldToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'annotation': value.annotation,
        'displayType': SingleChoiceDisplayTypeToJSON(value.displayType),
        'id': value.id,
        'label': value.label,
        'options': (value.options.map(ChoiceToJSON)),
        'required': value.required,
        'valueType': value.valueType,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
const StringValueType = {
    EMAIL: 'EMAIL',
    IBAN: 'IBAN',
    PHONE_NUMBER: 'PHONE_NUMBER',
    JSON: 'JSON'
};
function StringValueTypeFromJSON(json) {
    return StringValueTypeFromJSONTyped(json);
}
function StringValueTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function StringValueTypeToJSON(value) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
const TextDisplayType = {
    FIELD: 'TEXT_FIELD',
    AREA: 'TEXT_AREA'
};
function TextDisplayTypeFromJSON(json) {
    return TextDisplayTypeFromJSONTyped(json);
}
function TextDisplayTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function TextDisplayTypeToJSON(value) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const TextInputFieldValueTypeEnum = {
    TEXT: 'TEXT'
};
/**
 * Check if a given object implements the TextInputField interface.
 */
function instanceOfTextInputField(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "required" in value;
    isInstance = isInstance && "valueType" in value;
    return isInstance;
}
function TextInputFieldFromJSON(json) {
    return TextInputFieldFromJSONTyped(json);
}
function TextInputFieldFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'annotation': !exists(json, 'annotation') ? undefined : json['annotation'],
        'displayType': !exists(json, 'displayType') ? undefined : TextDisplayTypeFromJSON(json['displayType']),
        'id': json['id'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'maxLength': !exists(json, 'maxLength') ? undefined : json['maxLength'],
        'minLength': !exists(json, 'minLength') ? undefined : json['minLength'],
        'pattern': !exists(json, 'pattern') ? undefined : json['pattern'],
        'required': json['required'],
        'stringValueType': !exists(json, 'stringValueType') ? undefined : StringValueTypeFromJSON(json['stringValueType']),
        'valueType': json['valueType'],
    };
}
function TextInputFieldToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'annotation': value.annotation,
        'displayType': TextDisplayTypeToJSON(value.displayType),
        'id': value.id,
        'label': value.label,
        'maxLength': value.maxLength,
        'minLength': value.minLength,
        'pattern': value.pattern,
        'required': value.required,
        'stringValueType': StringValueTypeToJSON(value.stringValueType),
        'valueType': value.valueType,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function isBooleanInputField(value) {
    return value.valueType === "BOOLEAN";
}
function isDateInputField(value) {
    return value.valueType === "DATE";
}
function isDynamicChoiceInputField(value) {
    return value.valueType === "DYNAMIC_CHOICE";
}
function isFileInputField(value) {
    return value.valueType === "FILE";
}
function isMultipleChoiceInputField(value) {
    return value.valueType === "MULTIPLE_CHOICE";
}
function isNumberInputField(value) {
    return value.valueType === "NUMBER";
}
function isSingleChoiceInputField(value) {
    return value.valueType === "SINGLE_CHOICE";
}
function isTextInputField(value) {
    return value.valueType === "TEXT";
}
function InputFieldFromJSON(json) {
    return InputFieldFromJSONTyped(json);
}
function InputFieldFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['valueType']) {
        case 'BOOLEAN':
            return Object.assign(Object.assign({}, BooleanInputFieldFromJSONTyped(json)), { valueType: 'BOOLEAN' });
        case 'DATE':
            return Object.assign(Object.assign({}, DateInputFieldFromJSONTyped(json)), { valueType: 'DATE' });
        case 'DYNAMIC_CHOICE':
            return Object.assign(Object.assign({}, DynamicChoiceInputFieldFromJSONTyped(json)), { valueType: 'DYNAMIC_CHOICE' });
        case 'FILE':
            return Object.assign(Object.assign({}, FileInputFieldFromJSONTyped(json)), { valueType: 'FILE' });
        case 'MULTIPLE_CHOICE':
            return Object.assign(Object.assign({}, MultipleChoiceInputFieldFromJSONTyped(json)), { valueType: 'MULTIPLE_CHOICE' });
        case 'NUMBER':
            return Object.assign(Object.assign({}, NumberInputFieldFromJSONTyped(json)), { valueType: 'NUMBER' });
        case 'SINGLE_CHOICE':
            return Object.assign(Object.assign({}, SingleChoiceInputFieldFromJSONTyped(json)), { valueType: 'SINGLE_CHOICE' });
        case 'TEXT':
            return Object.assign(Object.assign({}, TextInputFieldFromJSONTyped(json)), { valueType: 'TEXT' });
        default:
            throw new Error(`No variant of InputField exists with 'valueType=${json['valueType']}'`);
    }
}
function InputFieldToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['valueType']) {
        case 'BOOLEAN':
            return BooleanInputFieldToJSON(value);
        case 'DATE':
            return DateInputFieldToJSON(value);
        case 'DYNAMIC_CHOICE':
            return DynamicChoiceInputFieldToJSON(value);
        case 'FILE':
            return FileInputFieldToJSON(value);
        case 'MULTIPLE_CHOICE':
            return MultipleChoiceInputFieldToJSON(value);
        case 'NUMBER':
            return NumberInputFieldToJSON(value);
        case 'SINGLE_CHOICE':
            return SingleChoiceInputFieldToJSON(value);
        case 'TEXT':
            return TextInputFieldToJSON(value);
        default:
            throw new Error(`No variant of InputField exists with 'valueType=${value['valueType']}'`);
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const InputNodeNodeTypeEnum = {
    INPUT: 'INPUT'
};
/**
 * Check if a given object implements the InputNode interface.
 */
function instanceOfInputNode(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "inputFields" in value;
    isInstance = isInstance && "nodeType" in value;
    return isInstance;
}
function InputNodeFromJSON(json) {
    return InputNodeFromJSONTyped(json);
}
function InputNodeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'description': !exists(json, 'description') ? undefined : json['description'],
        'hasMedia': !exists(json, 'hasMedia') ? undefined : json['hasMedia'],
        'highlightedMedia': !exists(json, 'highlightedMedia') ? undefined : (json['highlightedMedia'].map(FileReferenceFromJSON)),
        'hint': !exists(json, 'hint') ? undefined : json['hint'],
        'id': json['id'],
        'inputFields': (json['inputFields'].map(InputFieldFromJSON)),
        'instruction': !exists(json, 'instruction') ? undefined : json['instruction'],
        'introduction': !exists(json, 'introduction') ? undefined : json['introduction'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'mediaGallery': !exists(json, 'mediaGallery') ? undefined : (json['mediaGallery'].map(FileReferenceFromJSON)),
        'nodeType': json['nodeType'],
    };
}
function InputNodeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'description': value.description,
        'highlightedMedia': value.highlightedMedia === undefined ? undefined : (value.highlightedMedia.map(FileReferenceToJSON)),
        'hint': value.hint,
        'id': value.id,
        'inputFields': (value.inputFields.map(InputFieldToJSON)),
        'instruction': value.instruction,
        'introduction': value.introduction,
        'label': value.label,
        'mediaGallery': value.mediaGallery === undefined ? undefined : (value.mediaGallery.map(FileReferenceToJSON)),
        'nodeType': value.nodeType,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ModelNodeDispatchStep interface.
 */
function instanceOfModelNodeDispatchStep(value) {
    let isInstance = true;
    isInstance = isInstance && "idx" in value;
    isInstance = isInstance && "startDate" in value;
    return isInstance;
}
function ModelNodeDispatchStepFromJSON(json) {
    return ModelNodeDispatchStepFromJSONTyped(json);
}
function ModelNodeDispatchStepFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'description': !exists(json, 'description') ? undefined : json['description'],
        'idx': json['idx'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'nextStepDate': !exists(json, 'nextStepDate') ? undefined : json['nextStepDate'],
        'startDate': json['startDate'],
    };
}
function ModelNodeDispatchStepToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'description': value.description,
        'idx': value.idx,
        'label': value.label,
        'nextStepDate': value.nextStepDate,
        'startDate': value.startDate,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const ModelNodeNodeTypeEnum = {
    MODEL: 'MODEL'
};
/**
 * Check if a given object implements the ModelNode interface.
 */
function instanceOfModelNode(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "nestedRunId" in value;
    isInstance = isInstance && "nodeType" in value;
    return isInstance;
}
function ModelNodeFromJSON(json) {
    return ModelNodeFromJSONTyped(json);
}
function ModelNodeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'description': !exists(json, 'description') ? undefined : json['description'],
        'dispatchSteps': !exists(json, 'dispatchSteps') ? undefined : (json['dispatchSteps'].map(ModelNodeDispatchStepFromJSON)),
        'hasMedia': !exists(json, 'hasMedia') ? undefined : json['hasMedia'],
        'highlightedMedia': !exists(json, 'highlightedMedia') ? undefined : (json['highlightedMedia'].map(FileReferenceFromJSON)),
        'hint': !exists(json, 'hint') ? undefined : json['hint'],
        'id': json['id'],
        'instruction': !exists(json, 'instruction') ? undefined : json['instruction'],
        'introduction': !exists(json, 'introduction') ? undefined : json['introduction'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'linkLabel': !exists(json, 'linkLabel') ? undefined : json['linkLabel'],
        'mediaGallery': !exists(json, 'mediaGallery') ? undefined : (json['mediaGallery'].map(FileReferenceFromJSON)),
        'nestedRunId': json['nestedRunId'],
        'nestedRunUrl': !exists(json, 'nestedRunUrl') ? undefined : json['nestedRunUrl'],
        'nodeType': json['nodeType'],
    };
}
function ModelNodeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'description': value.description,
        'dispatchSteps': value.dispatchSteps === undefined ? undefined : (value.dispatchSteps.map(ModelNodeDispatchStepToJSON)),
        'highlightedMedia': value.highlightedMedia === undefined ? undefined : (value.highlightedMedia.map(FileReferenceToJSON)),
        'hint': value.hint,
        'id': value.id,
        'instruction': value.instruction,
        'introduction': value.introduction,
        'label': value.label,
        'linkLabel': value.linkLabel,
        'mediaGallery': value.mediaGallery === undefined ? undefined : (value.mediaGallery.map(FileReferenceToJSON)),
        'nestedRunId': value.nestedRunId,
        'nestedRunUrl': value.nestedRunUrl,
        'nodeType': value.nodeType,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function isChatNode(value) {
    return value.nodeType === "CHAT";
}
function isInputNode(value) {
    return value.nodeType === "INPUT";
}
function isModelNode(value) {
    return value.nodeType === "MODEL";
}
function isDisplayNode(value) {
    return value.nodeType === "PASSIVE";
}
function NodeFromJSON(json) {
    return NodeFromJSONTyped(json);
}
function NodeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['nodeType']) {
        case 'CHAT':
            return Object.assign(Object.assign({}, ChatNodeFromJSONTyped(json)), { nodeType: 'CHAT' });
        case 'INPUT':
            return Object.assign(Object.assign({}, InputNodeFromJSONTyped(json)), { nodeType: 'INPUT' });
        case 'MODEL':
            return Object.assign(Object.assign({}, ModelNodeFromJSONTyped(json)), { nodeType: 'MODEL' });
        case 'PASSIVE':
            return Object.assign(Object.assign({}, DisplayNodeFromJSONTyped(json)), { nodeType: 'PASSIVE' });
        default:
            throw new Error(`No variant of Node exists with 'nodeType=${json['nodeType']}'`);
    }
}
function NodeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['nodeType']) {
        case 'CHAT':
            return ChatNodeToJSON(value);
        case 'INPUT':
            return InputNodeToJSON(value);
        case 'MODEL':
            return ModelNodeToJSON(value);
        case 'PASSIVE':
            return DisplayNodeToJSON(value);
        default:
            throw new Error(`No variant of Node exists with 'nodeType=${value['nodeType']}'`);
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the HistoryStep interface.
 */
function instanceOfHistoryStep(value) {
    let isInstance = true;
    isInstance = isInstance && "inputMap" in value;
    isInstance = isInstance && "isReversible" in value;
    isInstance = isInstance && "node" in value;
    return isInstance;
}
function HistoryStepFromJSON(json) {
    return HistoryStepFromJSONTyped(json);
}
function HistoryStepFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'inputMap': (mapValues(json['inputMap'], NodeInputFromJSON)),
        'isReversible': json['isReversible'],
        'node': NodeFromJSON(json['node']),
    };
}
function HistoryStepToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'inputMap': (mapValues(value.inputMap, NodeInputToJSON)),
        'isReversible': value.isReversible,
        'node': NodeToJSON(value.node),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the InfoContent interface.
 */
function instanceOfInfoContent(value) {
    let isInstance = true;
    isInstance = isInstance && "infopoolDataMap" in value;
    return isInstance;
}
function InfoContentFromJSON(json) {
    return InfoContentFromJSONTyped(json);
}
function InfoContentFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'hint': !exists(json, 'hint') ? undefined : json['hint'],
        'infopoolDataMap': json['infopoolDataMap'],
    };
}
function InfoContentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'hint': value.hint,
        'infopoolDataMap': value.infopoolDataMap,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const InputNodeDataTargetNodeTypeEnum = {
    INPUT: 'INPUT'
};
/**
 * Check if a given object implements the InputNodeData interface.
 */
function instanceOfInputNodeData(value) {
    let isInstance = true;
    isInstance = isInstance && "inputMap" in value;
    return isInstance;
}
function InputNodeDataFromJSON(json) {
    return InputNodeDataFromJSONTyped(json);
}
function InputNodeDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'inputMap': (mapValues(json['inputMap'], NodeInputFromJSON)),
        'targetNodeType': !exists(json, 'targetNodeType') ? undefined : json['targetNodeType'],
    };
}
function InputNodeDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'inputMap': (mapValues(value.inputMap, NodeInputToJSON)),
        'targetNodeType': value.targetNodeType,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ModelInterface interface.
 */
function instanceOfModelInterface(value) {
    let isInstance = true;
    isInstance = isInstance && "inputFields" in value;
    isInstance = isInstance && "outputFields" in value;
    return isInstance;
}
function ModelInterfaceFromJSON(json) {
    return ModelInterfaceFromJSONTyped(json);
}
function ModelInterfaceFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'inputFields': (json['inputFields'].map(DataFieldOutlineFromJSON)),
        'outputFields': (json['outputFields'].map(DataFieldOutlineFromJSON)),
    };
}
function ModelInterfaceToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'inputFields': (value.inputFields.map(DataFieldOutlineToJSON)),
        'outputFields': (value.outputFields.map(DataFieldOutlineToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the NumberDataValueAllOf interface.
 */
function instanceOfNumberDataValueAllOf(value) {
    let isInstance = true;
    isInstance = isInstance && "number" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function NumberDataValueAllOfFromJSON(json) {
    return NumberDataValueAllOfFromJSONTyped(json);
}
function NumberDataValueAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'number': json['number'],
        'type': DataValueTypeFromJSON(json['type']),
    };
}
function NumberDataValueAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'number': value.number,
        'type': DataValueTypeToJSON(value.type),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const NumberDataValueAllOf1TypeEnum = {
    NUMBER: 'NUMBER'
};
/**
 * Check if a given object implements the NumberDataValueAllOf1 interface.
 */
function instanceOfNumberDataValueAllOf1(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function NumberDataValueAllOf1FromJSON(json) {
    return NumberDataValueAllOf1FromJSONTyped(json);
}
function NumberDataValueAllOf1FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': json['type'],
    };
}
function NumberDataValueAllOf1ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the Object88998051 interface.
 */
function instanceOfObject88998051(value) {
    let isInstance = true;
    return isInstance;
}
function Object88998051FromJSON(json) {
    return Object88998051FromJSONTyped(json);
}
function Object88998051FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'about': !exists(json, 'about') ? undefined : json['about'],
    };
}
function Object88998051ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'about': value.about,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const RootDataNodeTypeEnum = {
    ROOT: 'ROOT'
};
/**
 * Check if a given object implements the RootDataNode interface.
 */
function instanceOfRootDataNode(value) {
    let isInstance = true;
    isInstance = isInstance && "children" in value;
    return isInstance;
}
function RootDataNodeFromJSON(json) {
    return RootDataNodeFromJSONTyped(json);
}
function RootDataNodeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': !exists(json, 'type') ? undefined : json['type'],
        'children': (json['children'].map(DataNodeFromJSON)),
    };
}
function RootDataNodeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
        'children': (value.children.map(DataNodeToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PartyRoleDataUpdate interface.
 */
function instanceOfPartyRoleDataUpdate(value) {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "isMasterData" in value;
    isInstance = isInstance && "role" in value;
    return isInstance;
}
function PartyRoleDataUpdateFromJSON(json) {
    return PartyRoleDataUpdateFromJSONTyped(json);
}
function PartyRoleDataUpdateFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': RootDataNodeFromJSON(json['data']),
        'isMasterData': json['isMasterData'],
        'role': json['role'],
    };
}
function PartyRoleDataUpdateToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': RootDataNodeToJSON(value.data),
        'isMasterData': value.isMasterData,
        'role': value.role,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DynamicChoiceOption interface.
 */
function instanceOfDynamicChoiceOption(value) {
    let isInstance = true;
    isInstance = isInstance && "key" in value;
    return isInstance;
}
function DynamicChoiceOptionFromJSON(json) {
    return DynamicChoiceOptionFromJSONTyped(json);
}
function DynamicChoiceOptionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'annotation': !exists(json, 'annotation') ? undefined : json['annotation'],
        'key': json['key'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'media': !exists(json, 'media') ? undefined : KNSFileFromJSON(json['media']),
    };
}
function DynamicChoiceOptionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'annotation': value.annotation,
        'key': value.key,
        'label': value.label,
        'media': KNSFileToJSON(value.media),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RichTextDataValueAllOf interface.
 */
function instanceOfRichTextDataValueAllOf(value) {
    let isInstance = true;
    isInstance = isInstance && "text" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function RichTextDataValueAllOfFromJSON(json) {
    return RichTextDataValueAllOfFromJSONTyped(json);
}
function RichTextDataValueAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'text': RichTextNodeFromJSON(json['text']),
        'type': DataValueTypeFromJSON(json['type']),
    };
}
function RichTextDataValueAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'text': RichTextNodeToJSON(value.text),
        'type': DataValueTypeToJSON(value.type),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const RichTextDataValueAllOf1TypeEnum = {
    RICH_TEXT: 'RICH_TEXT'
};
/**
 * Check if a given object implements the RichTextDataValueAllOf1 interface.
 */
function instanceOfRichTextDataValueAllOf1(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function RichTextDataValueAllOf1FromJSON(json) {
    return RichTextDataValueAllOf1FromJSONTyped(json);
}
function RichTextDataValueAllOf1FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': json['type'],
    };
}
function RichTextDataValueAllOf1ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const RootDataNodeAllOfTypeEnum = {
    ROOT: 'ROOT'
};
/**
 * Check if a given object implements the RootDataNodeAllOf interface.
 */
function instanceOfRootDataNodeAllOf(value) {
    let isInstance = true;
    isInstance = isInstance && "children" in value;
    return isInstance;
}
function RootDataNodeAllOfFromJSON(json) {
    return RootDataNodeAllOfFromJSONTyped(json);
}
function RootDataNodeAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'children': (json['children'].map(DataNodeFromJSON)),
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}
function RootDataNodeAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'children': (value.children.map(DataNodeToJSON)),
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const RootDataNodeAllOf1TypeEnum = {
    ROOT_DATA_NODE: 'RootDataNode'
};
/**
 * Check if a given object implements the RootDataNodeAllOf1 interface.
 */
function instanceOfRootDataNodeAllOf1(value) {
    let isInstance = true;
    return isInstance;
}
function RootDataNodeAllOf1FromJSON(json) {
    return RootDataNodeAllOf1FromJSONTyped(json);
}
function RootDataNodeAllOf1FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}
function RootDataNodeAllOf1ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RunHistory interface.
 */
function instanceOfRunHistory(value) {
    let isInstance = true;
    isInstance = isInstance && "path" in value;
    return isInstance;
}
function RunHistoryFromJSON(json) {
    return RunHistoryFromJSONTyped(json);
}
function RunHistoryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'path': (json['path'].map(HistoryStepFromJSON)),
    };
}
function RunHistoryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'path': (value.path.map(HistoryStepToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RunWaitingState interface.
 */
function instanceOfRunWaitingState(value) {
    let isInstance = true;
    isInstance = isInstance && "isWaitingForUserAction" in value;
    return isInstance;
}
function RunWaitingStateFromJSON(json) {
    return RunWaitingStateFromJSONTyped(json);
}
function RunWaitingStateFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'description': !exists(json, 'description') ? undefined : json['description'],
        'isWaitingForUserAction': json['isWaitingForUserAction'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}
function RunWaitingStateToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'description': value.description,
        'isWaitingForUserAction': value.isWaitingForUserAction,
        'message': value.message,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RunState interface.
 */
function instanceOfRunState(value) {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "history" in value;
    isInstance = isInstance && "locale" in value;
    isInstance = isInstance && "modelId" in value;
    isInstance = isInstance && "node" in value;
    isInstance = isInstance && "progress" in value;
    isInstance = isInstance && "proposedInput" in value;
    isInstance = isInstance && "runId" in value;
    return isInstance;
}
function RunStateFromJSON(json) {
    return RunStateFromJSONTyped(json);
}
function RunStateFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': json['data'],
        'history': RunHistoryFromJSON(json['history']),
        'locale': json['locale'],
        'modelId': json['modelId'],
        'node': NodeFromJSON(json['node']),
        'progress': json['progress'],
        'proposedInput': (mapValues(json['proposedInput'], NodeInputFromJSON)),
        'runId': json['runId'],
        'waitingState': !exists(json, 'waitingState') ? undefined : RunWaitingStateFromJSON(json['waitingState']),
    };
}
function RunStateToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': value.data,
        'history': RunHistoryToJSON(value.history),
        'locale': value.locale,
        'modelId': value.modelId,
        'node': NodeToJSON(value.node),
        'progress': value.progress,
        'proposedInput': (mapValues(value.proposedInput, NodeInputToJSON)),
        'runId': value.runId,
        'waitingState': RunWaitingStateToJSON(value.waitingState),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
const RunStatus = {
    ACTIVE: 'ACTIVE',
    ABANDONED: 'ABANDONED',
    FINISHED: 'FINISHED',
    ERROR: 'ERROR'
};
function RunStatusFromJSON(json) {
    return RunStatusFromJSONTyped(json);
}
function RunStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function RunStatusToJSON(value) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RunInfo interface.
 */
function instanceOfRunInfo(value) {
    let isInstance = true;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "nestedRunIds" in value;
    isInstance = isInstance && "runId" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "status" in value;
    return isInstance;
}
function RunInfoFromJSON(json) {
    return RunInfoFromJSONTyped(json);
}
function RunInfoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'created': json['created'],
        'nestedRunIds': json['nestedRunIds'],
        'runId': json['runId'],
        'sections': !exists(json, 'sections') ? undefined : EvaluatedSectionsFromJSON(json['sections']),
        'state': RunStateFromJSON(json['state']),
        'status': RunStatusFromJSON(json['status']),
    };
}
function RunInfoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'created': value.created,
        'nestedRunIds': value.nestedRunIds,
        'runId': value.runId,
        'sections': EvaluatedSectionsToJSON(value.sections),
        'state': RunStateToJSON(value.state),
        'status': RunStatusToJSON(value.status),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RunInfosForModel interface.
 */
function instanceOfRunInfosForModel(value) {
    let isInstance = true;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "results" in value;
    return isInstance;
}
function RunInfosForModelFromJSON(json) {
    return RunInfosForModelFromJSONTyped(json);
}
function RunInfosForModelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'count': json['count'],
        'results': (json['results'].map(RunInfoFromJSON)),
    };
}
function RunInfosForModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'count': value.count,
        'results': (value.results.map(RunInfoToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
const RunMode = {
    LIVE: 'LIVE',
    TEST: 'TEST',
    PREVIEW: 'PREVIEW'
};
function RunModeFromJSON(json) {
    return RunModeFromJSONTyped(json);
}
function RunModeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function RunModeToJSON(value) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RunResult interface.
 */
function instanceOfRunResult(value) {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "fileInfo" in value;
    return isInstance;
}
function RunResultFromJSON(json) {
    return RunResultFromJSONTyped(json);
}
function RunResultFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': json['data'],
        'fileInfo': json['fileInfo'],
    };
}
function RunResultToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': value.data,
        'fileInfo': value.fileInfo,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
const StopReasonType = {
    INCOMPATIBLE_NODE_TYPE: 'INCOMPATIBLE_NODE_TYPE',
    PATH_MISSING: 'PATH_MISSING',
    DATA_ENVIRONMENT_CHANGED: 'DATA_ENVIRONMENT_CHANGED',
    INCOMPATIBLE_DATA_VALUE: 'INCOMPATIBLE_DATA_VALUE',
    INVALID_INPUT: 'INVALID_INPUT'
};
function StopReasonTypeFromJSON(json) {
    return StopReasonTypeFromJSONTyped(json);
}
function StopReasonTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function StopReasonTypeToJSON(value) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RunScenarioValidationStopReason interface.
 */
function instanceOfRunScenarioValidationStopReason(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "validationMessage" in value;
    return isInstance;
}
function RunScenarioValidationStopReasonFromJSON(json) {
    return RunScenarioValidationStopReasonFromJSONTyped(json);
}
function RunScenarioValidationStopReasonFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': StopReasonTypeFromJSON(json['type']),
        'validationMessage': json['validationMessage'],
    };
}
function RunScenarioValidationStopReasonToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': StopReasonTypeToJSON(value.type),
        'validationMessage': value.validationMessage,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RunScenarioExecutionResult interface.
 */
function instanceOfRunScenarioExecutionResult(value) {
    let isInstance = true;
    isInstance = isInstance && "executedUntil" in value;
    return isInstance;
}
function RunScenarioExecutionResultFromJSON(json) {
    return RunScenarioExecutionResultFromJSONTyped(json);
}
function RunScenarioExecutionResultFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'executedUntil': json['executedUntil'],
        'validationError': !exists(json, 'validationError') ? undefined : RunScenarioValidationStopReasonFromJSON(json['validationError']),
    };
}
function RunScenarioExecutionResultToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'executedUntil': value.executedUntil,
        'validationError': RunScenarioValidationStopReasonToJSON(value.validationError),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RunScenarioValidationResult interface.
 */
function instanceOfRunScenarioValidationResult(value) {
    let isInstance = true;
    isInstance = isInstance && "maxValidEventIdxPath" in value;
    isInstance = isInstance && "startEventIdxPath" in value;
    return isInstance;
}
function RunScenarioValidationResultFromJSON(json) {
    return RunScenarioValidationResultFromJSONTyped(json);
}
function RunScenarioValidationResultFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'maxValidEventIdxPath': json['maxValidEventIdxPath'],
        'startEventIdxPath': json['startEventIdxPath'],
        'stopReason': !exists(json, 'stopReason') ? undefined : RunScenarioValidationStopReasonFromJSON(json['stopReason']),
    };
}
function RunScenarioValidationResultToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'maxValidEventIdxPath': value.maxValidEventIdxPath,
        'startEventIdxPath': value.startEventIdxPath,
        'stopReason': RunScenarioValidationStopReasonToJSON(value.stopReason),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RunStateResponse interface.
 */
function instanceOfRunStateResponse(value) {
    let isInstance = true;
    isInstance = isInstance && "runId" in value;
    isInstance = isInstance && "state" in value;
    return isInstance;
}
function RunStateResponseFromJSON(json) {
    return RunStateResponseFromJSONTyped(json);
}
function RunStateResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'error': !exists(json, 'error') ? undefined : json['error'],
        'fileViewToken': !exists(json, 'fileViewToken') ? undefined : json['fileViewToken'],
        'readerUrl': !exists(json, 'readerUrl') ? undefined : json['readerUrl'],
        'result': !exists(json, 'result') ? undefined : RunResultFromJSON(json['result']),
        'runId': json['runId'],
        'state': RunStateFromJSON(json['state']),
    };
}
function RunStateResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'error': value.error,
        'fileViewToken': value.fileViewToken,
        'readerUrl': value.readerUrl,
        'result': RunResultToJSON(value.result),
        'runId': value.runId,
        'state': RunStateToJSON(value.state),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function isChatNodeData(value) {
    return value.targetNodeType === "CHAT";
}
function isInputNodeData(value) {
    return value.targetNodeType === "INPUT";
}
function RunSubmitDataFromJSON(json) {
    return RunSubmitDataFromJSONTyped(json);
}
function RunSubmitDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['targetNodeType']) {
        case 'CHAT':
            return Object.assign(Object.assign({}, ChatNodeDataFromJSONTyped(json)), { targetNodeType: 'CHAT' });
        case 'INPUT':
            return Object.assign(Object.assign({}, InputNodeDataFromJSONTyped(json)), { targetNodeType: 'INPUT' });
        default:
            throw new Error(`No variant of RunSubmitData exists with 'targetNodeType=${json['targetNodeType']}'`);
    }
}
function RunSubmitDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['targetNodeType']) {
        case 'CHAT':
            return ChatNodeDataToJSON(value);
        case 'INPUT':
            return InputNodeDataToJSON(value);
        default:
            throw new Error(`No variant of RunSubmitData exists with 'targetNodeType=${value['targetNodeType']}'`);
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ScenarioExecutableRequest interface.
 */
function instanceOfScenarioExecutableRequest(value) {
    let isInstance = true;
    isInstance = isInstance && "endEventIds" in value;
    isInstance = isInstance && "runScenarioRunId" in value;
    return isInstance;
}
function ScenarioExecutableRequestFromJSON(json) {
    return ScenarioExecutableRequestFromJSONTyped(json);
}
function ScenarioExecutableRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'currentRunId': !exists(json, 'currentRunId') ? undefined : json['currentRunId'],
        'endEventIds': json['endEventIds'],
        'runScenarioRunId': json['runScenarioRunId'],
    };
}
function ScenarioExecutableRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'currentRunId': value.currentRunId,
        'endEventIds': value.endEventIds,
        'runScenarioRunId': value.runScenarioRunId,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ServiceExchangeError interface.
 */
function instanceOfServiceExchangeError(value) {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    return isInstance;
}
function ServiceExchangeErrorFromJSON(json) {
    return ServiceExchangeErrorFromJSONTyped(json);
}
function ServiceExchangeErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'code': !exists(json, 'code') ? undefined : json['code'],
        'message': json['message'],
    };
}
function ServiceExchangeErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'code': value.code,
        'message': value.message,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the StringDataValueAllOf interface.
 */
function instanceOfStringDataValueAllOf(value) {
    let isInstance = true;
    isInstance = isInstance && "text" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function StringDataValueAllOfFromJSON(json) {
    return StringDataValueAllOfFromJSONTyped(json);
}
function StringDataValueAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'text': json['text'],
        'type': DataValueTypeFromJSON(json['type']),
    };
}
function StringDataValueAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'text': value.text,
        'type': DataValueTypeToJSON(value.type),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
const StringDataValueAllOf1TypeEnum = {
    STRING: 'STRING'
};
/**
 * Check if a given object implements the StringDataValueAllOf1 interface.
 */
function instanceOfStringDataValueAllOf1(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
function StringDataValueAllOf1FromJSON(json) {
    return StringDataValueAllOf1FromJSONTyped(json);
}
function StringDataValueAllOf1FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': json['type'],
    };
}
function StringDataValueAllOf1ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the TicketOutlineAttributes interface.
 */
function instanceOfTicketOutlineAttributes(value) {
    let isInstance = true;
    isInstance = isInstance && "customAttributeValues" in value;
    isInstance = isInstance && "standardAttributeValues" in value;
    return isInstance;
}
function TicketOutlineAttributesFromJSON(json) {
    return TicketOutlineAttributesFromJSONTyped(json);
}
function TicketOutlineAttributesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'customAttributeValues': (mapValues(json['customAttributeValues'], CustomAttributeValueFromJSON)),
        'standardAttributeValues': json['standardAttributeValues'],
    };
}
function TicketOutlineAttributesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'customAttributeValues': (mapValues(value.customAttributeValues, CustomAttributeValueToJSON)),
        'standardAttributeValues': value.standardAttributeValues,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the TicketReaderConfig interface.
 */
function instanceOfTicketReaderConfig(value) {
    let isInstance = true;
    isInstance = isInstance && "bodyFont" in value;
    isInstance = isInstance && "colors" in value;
    isInstance = isInstance && "configId" in value;
    isInstance = isInstance && "headerFont" in value;
    return isInstance;
}
function TicketReaderConfigFromJSON(json) {
    return TicketReaderConfigFromJSONTyped(json);
}
function TicketReaderConfigFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'bodyFont': FontConfigFromJSON(json['bodyFont']),
        'colors': ColorConfigFromJSON(json['colors']),
        'configId': json['configId'],
        'customCss': !exists(json, 'customCss') ? undefined : json['customCss'],
        'headerFont': FontConfigFromJSON(json['headerFont']),
        'nestedReaderConfigId': !exists(json, 'nestedReaderConfigId') ? undefined : json['nestedReaderConfigId'],
    };
}
function TicketReaderConfigToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'bodyFont': FontConfigToJSON(value.bodyFont),
        'colors': ColorConfigToJSON(value.colors),
        'configId': value.configId,
        'customCss': value.customCss,
        'headerFont': FontConfigToJSON(value.headerFont),
        'nestedReaderConfigId': value.nestedReaderConfigId,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the TicketViewStep interface.
 */
function instanceOfTicketViewStep(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "isCurrent" in value;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
function TicketViewStepFromJSON(json) {
    return TicketViewStepFromJSONTyped(json);
}
function TicketViewStepFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'isCurrent': json['isCurrent'],
        'name': json['name'],
    };
}
function TicketViewStepToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'isCurrent': value.isCurrent,
        'name': value.name,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the TicketViewMilestone interface.
 */
function instanceOfTicketViewMilestone(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "isCurrent" in value;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
function TicketViewMilestoneFromJSON(json) {
    return TicketViewMilestoneFromJSONTyped(json);
}
function TicketViewMilestoneFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'isCurrent': json['isCurrent'],
        'name': json['name'],
        'steps': !exists(json, 'steps') ? undefined : (json['steps'].map(TicketViewStepFromJSON)),
    };
}
function TicketViewMilestoneToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'isCurrent': value.isCurrent,
        'name': value.name,
        'steps': value.steps === undefined ? undefined : (value.steps.map(TicketViewStepToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the TicketViewProgress interface.
 */
function instanceOfTicketViewProgress(value) {
    let isInstance = true;
    return isInstance;
}
function TicketViewProgressFromJSON(json) {
    return TicketViewProgressFromJSONTyped(json);
}
function TicketViewProgressFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'milestones': !exists(json, 'milestones') ? undefined : (json['milestones'].map(TicketViewMilestoneFromJSON)),
        'progress': !exists(json, 'progress') ? undefined : json['progress'],
    };
}
function TicketViewProgressToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'milestones': value.milestones === undefined ? undefined : (value.milestones.map(TicketViewMilestoneToJSON)),
        'progress': value.progress,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the TicketState interface.
 */
function instanceOfTicketState(value) {
    let isInstance = true;
    isInstance = isInstance && "infoContent" in value;
    isInstance = isInstance && "progress" in value;
    isInstance = isInstance && "runId" in value;
    isInstance = isInstance && "runUrl" in value;
    return isInstance;
}
function TicketStateFromJSON(json) {
    return TicketStateFromJSONTyped(json);
}
function TicketStateFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'infoContent': InfoContentFromJSON(json['infoContent']),
        'progress': TicketViewProgressFromJSON(json['progress']),
        'runId': json['runId'],
        'runUrl': json['runUrl'],
    };
}
function TicketStateToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'infoContent': InfoContentToJSON(value.infoContent),
        'progress': TicketViewProgressToJSON(value.progress),
        'runId': value.runId,
        'runUrl': value.runUrl,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the TicketStateUpdate interface.
 */
function instanceOfTicketStateUpdate(value) {
    let isInstance = true;
    isInstance = isInstance && "dataMap" in value;
    isInstance = isInstance && "modelSignature" in value;
    isInstance = isInstance && "outline" in value;
    isInstance = isInstance && "partyRoleData" in value;
    isInstance = isInstance && "runId" in value;
    return isInstance;
}
function TicketStateUpdateFromJSON(json) {
    return TicketStateUpdateFromJSONTyped(json);
}
function TicketStateUpdateFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'dataMap': RootDataNodeFromJSON(json['dataMap']),
        'modelSignature': ModelSignatureFromJSON(json['modelSignature']),
        'outline': TicketOutlineAttributesFromJSON(json['outline']),
        'partyRoleData': (json['partyRoleData'].map(PartyRoleDataUpdateFromJSON)),
        'runId': json['runId'],
    };
}
function TicketStateUpdateToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'dataMap': RootDataNodeToJSON(value.dataMap),
        'modelSignature': ModelSignatureToJSON(value.modelSignature),
        'outline': TicketOutlineAttributesToJSON(value.outline),
        'partyRoleData': (value.partyRoleData.map(PartyRoleDataUpdateToJSON)),
        'runId': value.runId,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 */
class ConfigApi extends BaseAPI {
    /**
     * get default ticket reader config for model
     */
    getDefaultTicketReaderConfigForModelRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.modelId === null || requestParameters.modelId === undefined) {
                throw new RequiredError('modelId', 'Required parameter requestParameters.modelId was null or undefined when calling getDefaultTicketReaderConfigForModel.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/configs/model/{modelId}`.replace(`{${"modelId"}}`, encodeURIComponent(String(requestParameters.modelId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => TicketReaderConfigFromJSON(jsonValue));
        });
    }
    /**
     * get default ticket reader config for model
     */
    getDefaultTicketReaderConfigForModel(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getDefaultTicketReaderConfigForModelRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * get ticket reader config by id
     */
    getTicketReaderConfigByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.configId === null || requestParameters.configId === undefined) {
                throw new RequiredError('configId', 'Required parameter requestParameters.configId was null or undefined when calling getTicketReaderConfigById.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/configs/config/{configId}`.replace(`{${"configId"}}`, encodeURIComponent(String(requestParameters.configId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => TicketReaderConfigFromJSON(jsonValue));
        });
    }
    /**
     * get ticket reader config by id
     */
    getTicketReaderConfigById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getTicketReaderConfigByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 */
class DynamicChoiceApi extends BaseAPI {
    /**
     * Get option for key
     */
    getOptionForKeyRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.runId === null || requestParameters.runId === undefined) {
                throw new RequiredError('runId', 'Required parameter requestParameters.runId was null or undefined when calling getOptionForKey.');
            }
            if (requestParameters.inputFieldId === null || requestParameters.inputFieldId === undefined) {
                throw new RequiredError('inputFieldId', 'Required parameter requestParameters.inputFieldId was null or undefined when calling getOptionForKey.');
            }
            if (requestParameters.key === null || requestParameters.key === undefined) {
                throw new RequiredError('key', 'Required parameter requestParameters.key was null or undefined when calling getOptionForKey.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/kns/dynamic-choice/{runId}/{inputFieldId}/options/key/{key}`.replace(`{${"runId"}}`, encodeURIComponent(String(requestParameters.runId))).replace(`{${"inputFieldId"}}`, encodeURIComponent(String(requestParameters.inputFieldId))).replace(`{${"key"}}`, encodeURIComponent(String(requestParameters.key))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => DynamicChoiceOptionFromJSON(jsonValue));
        });
    }
    /**
     * Get option for key
     */
    getOptionForKey(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getOptionForKeyRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get options for query
     */
    getOptionsForQueryRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.runId === null || requestParameters.runId === undefined) {
                throw new RequiredError('runId', 'Required parameter requestParameters.runId was null or undefined when calling getOptionsForQuery.');
            }
            if (requestParameters.inputFieldId === null || requestParameters.inputFieldId === undefined) {
                throw new RequiredError('inputFieldId', 'Required parameter requestParameters.inputFieldId was null or undefined when calling getOptionsForQuery.');
            }
            if (requestParameters.queryBase64 === null || requestParameters.queryBase64 === undefined) {
                throw new RequiredError('queryBase64', 'Required parameter requestParameters.queryBase64 was null or undefined when calling getOptionsForQuery.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/kns/dynamic-choice/{runId}/{inputFieldId}/options/query/{queryBase64}`.replace(`{${"runId"}}`, encodeURIComponent(String(requestParameters.runId))).replace(`{${"inputFieldId"}}`, encodeURIComponent(String(requestParameters.inputFieldId))).replace(`{${"queryBase64"}}`, encodeURIComponent(String(requestParameters.queryBase64))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(DynamicChoiceOptionFromJSON));
        });
    }
    /**
     * Get options for query
     */
    getOptionsForQuery(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getOptionsForQueryRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get recommended options
     */
    getRecommendedOptionsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.runId === null || requestParameters.runId === undefined) {
                throw new RequiredError('runId', 'Required parameter requestParameters.runId was null or undefined when calling getRecommendedOptions.');
            }
            if (requestParameters.inputFieldId === null || requestParameters.inputFieldId === undefined) {
                throw new RequiredError('inputFieldId', 'Required parameter requestParameters.inputFieldId was null or undefined when calling getRecommendedOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/kns/dynamic-choice/{runId}/{inputFieldId}/options/recommended`.replace(`{${"runId"}}`, encodeURIComponent(String(requestParameters.runId))).replace(`{${"inputFieldId"}}`, encodeURIComponent(String(requestParameters.inputFieldId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(DynamicChoiceOptionFromJSON));
        });
    }
    /**
     * Get recommended options
     */
    getRecommendedOptions(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getRecommendedOptionsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 */
class FilesApi extends BaseAPI {
    /**
     * Get file data
     */
    getFileDataRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.token === null || requestParameters.token === undefined) {
                throw new RequiredError('token', 'Required parameter requestParameters.token was null or undefined when calling getFileData.');
            }
            if (requestParameters.fileId === null || requestParameters.fileId === undefined) {
                throw new RequiredError('fileId', 'Required parameter requestParameters.fileId was null or undefined when calling getFileData.');
            }
            const queryParameters = {};
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            if (requestParameters.preview !== undefined) {
                queryParameters['preview'] = requestParameters.preview;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/files/get/{fileId}`.replace(`{${"fileId"}}`, encodeURIComponent(String(requestParameters.fileId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new BlobApiResponse(response);
        });
    }
    /**
     * Get file data
     */
    getFileData(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getFileDataRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get file metadata
     */
    getFileMetadataRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.token === null || requestParameters.token === undefined) {
                throw new RequiredError('token', 'Required parameter requestParameters.token was null or undefined when calling getFileMetadata.');
            }
            if (requestParameters.fileId === null || requestParameters.fileId === undefined) {
                throw new RequiredError('fileId', 'Required parameter requestParameters.fileId was null or undefined when calling getFileMetadata.');
            }
            const queryParameters = {};
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/files/meta/{fileId}`.replace(`{${"fileId"}}`, encodeURIComponent(String(requestParameters.fileId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => FileResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get file metadata
     */
    getFileMetadata(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getFileMetadataRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get file data optimized for browser preview
     */
    getFilePreviewRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.token === null || requestParameters.token === undefined) {
                throw new RequiredError('token', 'Required parameter requestParameters.token was null or undefined when calling getFilePreview.');
            }
            if (requestParameters.fileId === null || requestParameters.fileId === undefined) {
                throw new RequiredError('fileId', 'Required parameter requestParameters.fileId was null or undefined when calling getFilePreview.');
            }
            const queryParameters = {};
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/files/preview/{fileId}`.replace(`{${"fileId"}}`, encodeURIComponent(String(requestParameters.fileId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new BlobApiResponse(response);
        });
    }
    /**
     * Get file data optimized for browser preview
     */
    getFilePreview(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getFilePreviewRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Upload a file
     */
    uploadFileRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.data === null || requestParameters.data === undefined) {
                throw new RequiredError('data', 'Required parameter requestParameters.data was null or undefined when calling uploadFile.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm$1 = canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm$1;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters.data !== undefined) {
                formParams.append('data', requestParameters.data);
            }
            const response = yield this.request({
                path: `/api/files/upload`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => FileResponseFromJSON(jsonValue));
        });
    }
    /**
     * Upload a file
     */
    uploadFile(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.uploadFileRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 */
class RunScenarioApi extends BaseAPI {
    /**
     * Validate the run scenario (internal)
     */
    apiValidateRunScenarioRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.scenarioExecutableRequest === null || requestParameters.scenarioExecutableRequest === undefined) {
                throw new RequiredError('scenarioExecutableRequest', 'Required parameter requestParameters.scenarioExecutableRequest was null or undefined when calling apiValidateRunScenario.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-CDC-KNS-IC"] = this.configuration.apiKey("X-CDC-KNS-IC"); // api_key authentication
            }
            const response = yield this.request({
                path: `/api/scenarios/validate`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ScenarioExecutableRequestToJSON(requestParameters.scenarioExecutableRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => RunScenarioValidationResultFromJSON(jsonValue));
        });
    }
    /**
     * Validate the run scenario (internal)
     */
    apiValidateRunScenario(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiValidateRunScenarioRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Execute the current run with the run scenario
     */
    executeRunScenarioRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.scenarioExecutableRequest === null || requestParameters.scenarioExecutableRequest === undefined) {
                throw new RequiredError('scenarioExecutableRequest', 'Required parameter requestParameters.scenarioExecutableRequest was null or undefined when calling executeRunScenario.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-CDC-KNS-IC"] = this.configuration.apiKey("X-CDC-KNS-IC"); // api_key authentication
            }
            const response = yield this.request({
                path: `/api/scenarios/execute`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ScenarioExecutableRequestToJSON(requestParameters.scenarioExecutableRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => RunScenarioExecutionResultFromJSON(jsonValue));
        });
    }
    /**
     * Execute the current run with the run scenario
     */
    executeRunScenario(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.executeRunScenarioRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 */
class RunsApi extends BaseAPI {
    /**
     * Abandon a run
     */
    abandonRunRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.runId === null || requestParameters.runId === undefined) {
                throw new RequiredError('runId', 'Required parameter requestParameters.runId was null or undefined when calling abandonRun.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/kns/abandon/{runId}`.replace(`{${"runId"}}`, encodeURIComponent(String(requestParameters.runId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => RunStateResponseFromJSON(jsonValue));
        });
    }
    /**
     * Abandon a run
     */
    abandonRun(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.abandonRunRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Delete a run
     */
    deleteRunRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.runId === null || requestParameters.runId === undefined) {
                throw new RequiredError('runId', 'Required parameter requestParameters.runId was null or undefined when calling deleteRun.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/kns/delete/{runId}`.replace(`{${"runId"}}`, encodeURIComponent(String(requestParameters.runId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Delete a run
     */
    deleteRun(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteRunRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Get a run
     */
    getRunRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.runId === null || requestParameters.runId === undefined) {
                throw new RequiredError('runId', 'Required parameter requestParameters.runId was null or undefined when calling getRun.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xCDCTimezone !== undefined && requestParameters.xCDCTimezone !== null) {
                headerParameters['X-CDC-Timezone'] = String(requestParameters.xCDCTimezone);
            }
            const response = yield this.request({
                path: `/api/kns/get/{runId}`.replace(`{${"runId"}}`, encodeURIComponent(String(requestParameters.runId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => RunStateResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get a run
     */
    getRun(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getRunRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * get run by id
     */
    getRunByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.runId === null || requestParameters.runId === undefined) {
                throw new RequiredError('runId', 'Required parameter requestParameters.runId was null or undefined when calling getRunById.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-CDC-KNS-API-KEY"] = this.configuration.apiKey("X-CDC-KNS-API-KEY"); // knsApiKey authentication
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("knsApiToken", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/runs/{runId}`.replace(`{${"runId"}}`, encodeURIComponent(String(requestParameters.runId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => RunInfoFromJSON(jsonValue));
        });
    }
    /**
     * get run by id
     */
    getRunById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getRunByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * get runs for model
     */
    getRunsForModelRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.modelId === null || requestParameters.modelId === undefined) {
                throw new RequiredError('modelId', 'Required parameter requestParameters.modelId was null or undefined when calling getRunsForModel.');
            }
            const queryParameters = {};
            if (requestParameters.mode !== undefined) {
                queryParameters['mode'] = requestParameters.mode;
            }
            if (requestParameters.limit !== undefined) {
                queryParameters['limit'] = requestParameters.limit;
            }
            if (requestParameters.from !== undefined) {
                queryParameters['from'] = requestParameters.from;
            }
            if (requestParameters.to !== undefined) {
                queryParameters['to'] = requestParameters.to;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-CDC-KNS-API-KEY"] = this.configuration.apiKey("X-CDC-KNS-API-KEY"); // knsApiKey authentication
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("knsApiToken", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/models/{modelId}/runs`.replace(`{${"modelId"}}`, encodeURIComponent(String(requestParameters.modelId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => RunInfosForModelFromJSON(jsonValue));
        });
    }
    /**
     * get runs for model
     */
    getRunsForModel(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getRunsForModelRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get ticket state update (Client Portal only)
     */
    getTicketStateUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.runId === null || requestParameters.runId === undefined) {
                throw new RequiredError('runId', 'Required parameter requestParameters.runId was null or undefined when calling getTicketStateUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-CDC-KNS-IC"] = this.configuration.apiKey("X-CDC-KNS-IC"); // api_key authentication
            }
            const response = yield this.request({
                path: `/api/kns/ticket-state-update/{runId}`.replace(`{${"runId"}}`, encodeURIComponent(String(requestParameters.runId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => TicketStateUpdateFromJSON(jsonValue));
        });
    }
    /**
     * Get ticket state update (Client Portal only)
     */
    getTicketStateUpdate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getTicketStateUpdateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Go to a specific history index
     */
    goToHistoryIdxRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.runId === null || requestParameters.runId === undefined) {
                throw new RequiredError('runId', 'Required parameter requestParameters.runId was null or undefined when calling goToHistoryIdx.');
            }
            if (requestParameters.historyIdx === null || requestParameters.historyIdx === undefined) {
                throw new RequiredError('historyIdx', 'Required parameter requestParameters.historyIdx was null or undefined when calling goToHistoryIdx.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/kns/go/{runId}/{historyIdx}`.replace(`{${"runId"}}`, encodeURIComponent(String(requestParameters.runId))).replace(`{${"historyIdx"}}`, encodeURIComponent(String(requestParameters.historyIdx))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => RunStateResponseFromJSON(jsonValue));
        });
    }
    /**
     * Go to a specific history index
     */
    goToHistoryIdx(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.goToHistoryIdxRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Start a new run
     */
    startRunRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.modelId === null || requestParameters.modelId === undefined) {
                throw new RequiredError('modelId', 'Required parameter requestParameters.modelId was null or undefined when calling startRun.');
            }
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling startRun.');
            }
            const queryParameters = {};
            if (requestParameters.version !== undefined) {
                queryParameters['version'] = requestParameters.version;
            }
            if (requestParameters.mode !== undefined) {
                queryParameters['mode'] = requestParameters.mode;
            }
            if (requestParameters.config !== undefined) {
                queryParameters['config'] = requestParameters.config;
            }
            if (requestParameters.language !== undefined) {
                queryParameters['language'] = requestParameters.language;
            }
            if (requestParameters.finishedCallbackUrl !== undefined) {
                queryParameters['finishedCallbackUrl'] = requestParameters.finishedCallbackUrl;
            }
            if (requestParameters.previewToken !== undefined) {
                queryParameters['previewToken'] = requestParameters.previewToken;
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/kns/start/{modelId}`.replace(`{${"modelId"}}`, encodeURIComponent(String(requestParameters.modelId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => RunStateResponseFromJSON(jsonValue));
        });
    }
    /**
     * Start a new run
     */
    startRun(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.startRunRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Start a new run
     */
    startRunRedirectRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.modelId === null || requestParameters.modelId === undefined) {
                throw new RequiredError('modelId', 'Required parameter requestParameters.modelId was null or undefined when calling startRunRedirect.');
            }
            const queryParameters = {};
            if (requestParameters.version !== undefined) {
                queryParameters['version'] = requestParameters.version;
            }
            if (requestParameters.mode !== undefined) {
                queryParameters['mode'] = requestParameters.mode;
            }
            if (requestParameters.config !== undefined) {
                queryParameters['config'] = requestParameters.config;
            }
            if (requestParameters.language !== undefined) {
                queryParameters['language'] = requestParameters.language;
            }
            if (requestParameters.scopeNodeId !== undefined) {
                queryParameters['scopeNodeId'] = requestParameters.scopeNodeId;
            }
            if (requestParameters.finishedCallbackUrl !== undefined) {
                queryParameters['finishedCallbackUrl'] = requestParameters.finishedCallbackUrl;
            }
            if (requestParameters.previewToken !== undefined) {
                queryParameters['previewToken'] = requestParameters.previewToken;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/kns/start/{modelId}`.replace(`{${"modelId"}}`, encodeURIComponent(String(requestParameters.modelId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Start a new run
     */
    startRunRedirect(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.startRunRedirectRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Submit run input
     */
    submitRunRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.runId === null || requestParameters.runId === undefined) {
                throw new RequiredError('runId', 'Required parameter requestParameters.runId was null or undefined when calling submitRun.');
            }
            if (requestParameters.runSubmitData === null || requestParameters.runSubmitData === undefined) {
                throw new RequiredError('runSubmitData', 'Required parameter requestParameters.runSubmitData was null or undefined when calling submitRun.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/kns/submit/{runId}`.replace(`{${"runId"}}`, encodeURIComponent(String(requestParameters.runId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: RunSubmitDataToJSON(requestParameters.runSubmitData),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => RunStateResponseFromJSON(jsonValue));
        });
    }
    /**
     * Submit run input
     */
    submitRun(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.submitRunRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 */
class ScopedRunsApi extends BaseAPI {
    /**
     * Create a scoped run link
     */
    createScopedRunRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.runId === null || requestParameters.runId === undefined) {
                throw new RequiredError('runId', 'Required parameter requestParameters.runId was null or undefined when calling createScopedRun.');
            }
            if (requestParameters.nodeId === null || requestParameters.nodeId === undefined) {
                throw new RequiredError('nodeId', 'Required parameter requestParameters.nodeId was null or undefined when calling createScopedRun.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/kns/scoped-run/create/{runId}/{nodeId}`.replace(`{${"runId"}}`, encodeURIComponent(String(requestParameters.runId))).replace(`{${"nodeId"}}`, encodeURIComponent(String(requestParameters.nodeId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Create a scoped run link
     */
    createScopedRun(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.createScopedRunRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Create a scoped run link
     */
    createScopedRunRedirectRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.runId === null || requestParameters.runId === undefined) {
                throw new RequiredError('runId', 'Required parameter requestParameters.runId was null or undefined when calling createScopedRunRedirect.');
            }
            if (requestParameters.nodeId === null || requestParameters.nodeId === undefined) {
                throw new RequiredError('nodeId', 'Required parameter requestParameters.nodeId was null or undefined when calling createScopedRunRedirect.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/kns/scoped-run/create/{runId}/{nodeId}`.replace(`{${"runId"}}`, encodeURIComponent(String(requestParameters.runId))).replace(`{${"nodeId"}}`, encodeURIComponent(String(requestParameters.nodeId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Create a scoped run link
     */
    createScopedRunRedirect(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.createScopedRunRedirectRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Scoped run viewer
     */
    viewScopedRunRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.scope === null || requestParameters.scope === undefined) {
                throw new RequiredError('scope', 'Required parameter requestParameters.scope was null or undefined when calling viewScopedRun.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/kns/scoped-run/view/{scope}`.replace(`{${"scope"}}`, encodeURIComponent(String(requestParameters.scope))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Scoped run viewer
     */
    viewScopedRun(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.viewScopedRunRaw(requestParameters, initOverrides);
        });
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 */
class ServiceApi extends BaseAPI {
    /**
     * Submit a service exchange error
     */
    submitServiceExchangeErrorRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.runId === null || requestParameters.runId === undefined) {
                throw new RequiredError('runId', 'Required parameter requestParameters.runId was null or undefined when calling submitServiceExchangeError.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/kns/service-exchange/submit-error/{runId}`.replace(`{${"runId"}}`, encodeURIComponent(String(requestParameters.runId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => ServiceExchangeErrorFromJSON(jsonValue));
        });
    }
    /**
     * Submit a service exchange error
     */
    submitServiceExchangeError(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.submitServiceExchangeErrorRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Submit a service exchange response
     */
    submitServiceExchangeResponseRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.runId === null || requestParameters.runId === undefined) {
                throw new RequiredError('runId', 'Required parameter requestParameters.runId was null or undefined when calling submitServiceExchangeResponse.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/kns/service-exchange/submit/{runId}`.replace(`{${"runId"}}`, encodeURIComponent(String(requestParameters.runId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => Object88998051FromJSON(jsonValue));
        });
    }
    /**
     * Submit a service exchange response
     */
    submitServiceExchangeResponse(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.submitServiceExchangeResponseRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 */
class TicketsApi extends BaseAPI {
    /**
     * Get a ticket (Client Portal only)
     */
    getTicketRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.runId === null || requestParameters.runId === undefined) {
                throw new RequiredError('runId', 'Required parameter requestParameters.runId was null or undefined when calling getTicket.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-CDC-KNS-IC"] = this.configuration.apiKey("X-CDC-KNS-IC"); // api_key authentication
            }
            const response = yield this.request({
                path: `/api/tickets/ticket/{runId}`.replace(`{${"runId"}}`, encodeURIComponent(String(requestParameters.runId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => TicketStateFromJSON(jsonValue));
        });
    }
    /**
     * Get a ticket (Client Portal only)
     */
    getTicket(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getTicketRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get a ticket\'s data map (Client Portal only)
     */
    getTicketDataMapRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.runId === null || requestParameters.runId === undefined) {
                throw new RequiredError('runId', 'Required parameter requestParameters.runId was null or undefined when calling getTicketDataMap.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-CDC-KNS-IC"] = this.configuration.apiKey("X-CDC-KNS-IC"); // api_key authentication
            }
            const response = yield this.request({
                path: `/api/tickets/ticket/data-map/{runId}`.replace(`{${"runId"}}`, encodeURIComponent(String(requestParameters.runId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => RootDataNodeFromJSON(jsonValue));
        });
    }
    /**
     * Get a ticket\'s data map (Client Portal only)
     */
    getTicketDataMap(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getTicketDataMapRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 */
class TicketsDocumentProviderApi extends BaseAPI {
    /**
     * Get run history as text
     */
    getRunHistoryTextRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.runId === null || requestParameters.runId === undefined) {
                throw new RequiredError('runId', 'Required parameter requestParameters.runId was null or undefined when calling getRunHistoryText.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-CDC-KNS-IC"] = this.configuration.apiKey("X-CDC-KNS-IC"); // api_key authentication
            }
            const response = yield this.request({
                path: `/api/tickets/service/document-provider/run-history/{runId}`.replace(`{${"runId"}}`, encodeURIComponent(String(requestParameters.runId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Get run history as text
     */
    getRunHistoryText(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getRunHistoryTextRaw(requestParameters, initOverrides);
        });
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * KNS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 */
class TicketsModelProviderApi extends BaseAPI {
    /**
     * Get model interface
     */
    getModelInterfaceRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.getModelInterfaceRequest === null || requestParameters.getModelInterfaceRequest === undefined) {
                throw new RequiredError('getModelInterfaceRequest', 'Required parameter requestParameters.getModelInterfaceRequest was null or undefined when calling getModelInterface.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-CDC-KNS-IC"] = this.configuration.apiKey("X-CDC-KNS-IC"); // api_key authentication
            }
            const response = yield this.request({
                path: `/api/tickets/service/model/interface`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: GetModelInterfaceRequestToJSON(requestParameters.getModelInterfaceRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => ModelInterfaceFromJSON(jsonValue));
        });
    }
    /**
     * Get model interface
     */
    getModelInterface(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getModelInterfaceRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}

const BooleanInputUtils = {
    // Keep same paramaters as on other validation functions for consistency
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    validateInput: function (field, value) {
        return { valid: true };
    },
    asNodeInput: function (value) {
        return { type: "BOOLEAN", value: value };
    },
    valueFromNodeInput: function (input) {
        if (instanceOfBooleanNodeInput(input)) {
            return input.value;
        }
        else
            return null;
    },
};

dayjs.extend(customParseFormat);
const DateFormats = {
    Date: {
        format: "D.M.YYYY",
        regexp: /^\d{1,2}\.\d{1,2}\.\d{4}$/g
    },
    DateTime: {
        format: "D.M.YYYY H:mm",
        regexp: /^\d{1,2}\.\d{1,2}\.\d{4}\s\d{1,2}:\d{2}$/g
    },
    HTMLInput: {
        format: "YYYY-MM-DD",
        regexp: /^\d{4}-\d{2}-\d{2}$/g
    }
};
const DateInputUtils = {
    valueFromNodeInput: function (input) {
        if (isDateNodeInput(input)) {
            return input.date;
        }
        else
            return null;
    },
    /** @returns Date as ISO string or undefined if parsing failed */
    parseDate: function (field, input) {
        // Check whether input is already an ISO date
        if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z?$/g.test(input)) {
            // We have an ISO date, no need to parse
            return input;
        }
        const format = this.getDateInputFormat(field);
        // Try to parse using "normal" input format
        let parsedDate = input && input.match(format.regexp)
            ? dayjs(input, format.format) // TODO Include user format for compatibility
            : undefined;
        // Try to parse as date sent by HTML picker
        if (!parsedDate && input.match(DateFormats.HTMLInput.regexp)) {
            parsedDate = dayjs(input, DateFormats.HTMLInput.format);
        }
        // If time of day is not recorded or not specified, choose 12h
        if (parsedDate && parsedDate.isValid()) {
            const isDayTimeSpecified = (input.match(DateFormats.Date.regexp) || [])[0] != input;
            if (!isDayTimeSpecified) {
                parsedDate = parsedDate.hour(12);
            }
        }
        return parsedDate && parsedDate.isValid()
            ? parsedDate.toISOString()
            : undefined;
    },
    validateDate: function (field, isoDateString) {
        const date = dayjs(isoDateString);
        const validation = {
            valid: false,
            upperLimitExceeded: false,
            lowerLimitExceeded: false
        };
        // Check whether date is empty
        if (!isoDateString) {
            return validation;
        }
        // Check constraints
        const dateConstraints = this.getDateConstraints(field);
        const minDate = dateConstraints.minDate != null ? dayjs(dateConstraints.minDate) : null;
        const maxDate = dateConstraints.maxDate != null ? dayjs(dateConstraints.maxDate) : null;
        if (date.isValid()) {
            validation.lowerLimitExceeded = !!minDate && (minDate.isValid() && minDate.isAfter(date));
            validation.upperLimitExceeded = !!maxDate && (maxDate.isValid() && maxDate.isBefore(date));
        }
        validation.valid = !(validation.upperLimitExceeded || validation.lowerLimitExceeded);
        return validation;
    },
    validateInput: function (field, input) {
        return this.validateDate(field, this.parseDate(field, input));
    },
    asNodeInput: function (date) {
        return { type: "DATE", date: date };
    },
    getDateConstraints: function (field) {
        return {
            minDate: field.minToday
                ? dayjs().hour(0).minute(0).second(0).toDate()
                : field.minDate ? dayjs(field.minDate).toDate() : undefined,
            maxDate: field.maxToday
                ? dayjs().hour(23).minute(59).second(59).toDate()
                : field.maxDate ? dayjs(field.maxDate).toDate() : undefined
        };
    },
    formatISODateString: function (field, isoDateString) {
        return dayjs(isoDateString).format(this.getDateInputFormat(field).format);
    },
    formatDate: function (field, date) {
        return dayjs(date).format(this.getDateInputFormat(field).format);
    },
    /**
     * @param isoDateString The date string to format
     * @return Date string in a format accepted by input's "value" attribute
     */
    formatISODateStringForHTMLDateInput: function (isoDateString) {
        return dayjs(isoDateString).format(DateFormats.HTMLInput.format);
    },
    getDateInputFormat: function (field) {
        return field.includeTimeOfDay
            ? DateFormats.DateTime
            : DateFormats.Date;
    }
};

const DynamicChoiceInputUtils = {
    asNodeInput: function (value) {
        return { type: "DYNAMIC_CHOICE", key: value.key, label: value.label };
    },
    // Keep same paramaters as on other validation functions for consistency
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    validateInput: function (field, value) {
        return { valid: true };
    },
    valueFromNodeInput: function (input) {
        if (isDynamicChoiceNodeInput(input)) {
            return { key: input.key, label: input.label };
        }
        else
            return null;
    },
};
function createDynamicChoiceApiRoutesFromUrl(url) {
    if (url.endsWith("/")) {
        url = url.substring(0, url.length - 1);
    }
    return {
        getOptionsForQuery: (query) => fetch(url + "/options/query/" + Base64.encode(query))
            .then(resp => resp.json())
            .then(json => json)
            .catch(e => {
            console.error(`Failed to query dynamic choice api at ${url} for query '${query}':`, e);
            throw e;
        }),
        getRecommendedOptions: () => fetch(url + "/options/recommended")
            .then(resp => resp.json())
            .then(json => json)
            .catch(e => {
            console.error(`Failed to query dynamic choice api at ${url} for recommended options:`, e);
            throw e;
        }),
        getOptionForKey: (key) => fetch(url + "/options/key/" + Base64.encode(key))
            .then(resp => resp.json())
            .then(json => json)
            .catch(e => {
            console.error(`Failed to query dynamic choice api at ${url} for key '${key}':`, e);
            throw e;
        })
    };
}

const FileInputUtils = {
    /** @returns Nicely formatted file size string, e.g. "100 KB", "2 MB" etc. */
    formatFileSize: function (fileSize) {
        if (fileSize == null) {
            return "0 B";
        }
        else if (fileSize < 1024) {
            return fileSize + " B";
        }
        else if (fileSize < (1024 * 1000)) {
            return Math.round(fileSize / 1024) + " KB"; // TODO localize this, e.g. in France it's KO, MO, GO ...
        }
        else if (fileSize < (1024 * 1e6)) {
            return Math.round(fileSize / (1024 * 1e3)) + " MB";
        }
        else {
            return Math.round(fileSize / (1024 * 1e6)) + " GB";
        }
    },
    getLowerCaseExtensionFromFileName: getLowerCaseExtensionFromFileName,
    asNodeInput: function (file) {
        if (isKNSFile(file)) {
            return { type: "FILE", file };
        }
        else {
            return { type: "EMPTY" };
        }
    },
    validateInput: function (field, input) {
        if (isKNSFile(input)) {
            return { valid: true, illegalExtension: false, isTooLarge: false };
        }
        else {
            const file = input;
            const isEmpty = false;
            const illegalExtension = (field.allowedExtensions && file) ?
                !field.allowedExtensions.includes(getLowerCaseExtensionFromFileName(file === null || file === void 0 ? void 0 : file.name)) : false;
            /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
            const maxFileSize = window.__cdc_maxFileUploadSize;
            const isTooLarge = maxFileSize != null && (file.size > maxFileSize);
            return {
                valid: !(field.required && isEmpty) && !illegalExtension && !isTooLarge,
                illegalExtension: illegalExtension,
                isTooLarge: isTooLarge,
            };
        }
    },
    valueFromNodeInput: function (input) {
        if (isFileNodeInput(input)) {
            return input.file;
        }
        else {
            return null;
        }
    },
};
function getLowerCaseExtensionFromFileName(fileName) {
    if (fileName) {
        const parts = fileName.split(".");
        return parts.length ? parts[parts.length - 1].toLowerCase() : "";
    }
    return "";
}
function isKNSFile(input) {
    return "id" in input && "name" in input;
}

const MultipleChoiceInputUtils = {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    validateInput: function (field, selectedOptions) {
        return { valid: true };
    },
    asNodeInput: function (selectedOptionIds) {
        return { type: "MULTIPLE_CHOICE", selectedOptionIds: selectedOptionIds };
    },
    toggleOption(selectedOptions, optionId) {
        let newSelection = [];
        if (selectedOptions.includes(optionId)) {
            // Remove option
            newSelection = selectedOptions.filter((optId) => optId != optionId);
        }
        else {
            // Add option
            newSelection = selectedOptions.concat(optionId);
        }
        return newSelection;
    },
    valueFromNodeInput: function (input) {
        if (isMultipleChoiceNodeInput(input)) {
            return input.selectedOptionIds;
        }
        else
            return null;
    },
};

const NumberInputUtils = {
    cleanInput: function (input, integersOnly) {
        return input.replace(integersOnly ? /[^-0-9]/g : /[^-0-9.,]/g, "");
    },
    parseNumber: function (input) {
        const asNumber = input.length > 0 ? Number(input.replace(/,/g, ".")) : undefined;
        return (asNumber != undefined && !isNaN(asNumber)) ? asNumber : undefined;
    },
    /** Check whether a given number is a valid input for the given node */
    validateInput: function (field, number) {
        const { minValue, maxValue, integersOnly } = this.getNumberConstraints(field);
        const validation = {
            valid: false,
            lowerLimitExceeded: minValue != null && number < minValue,
            upperLimitExceeded: maxValue != null && number > maxValue,
            integerConstraintViolated: integersOnly && (number != Math.floor(number))
        };
        validation.valid = !(validation.upperLimitExceeded || validation.lowerLimitExceeded || validation.integerConstraintViolated);
        return validation;
    },
    /** Check whether a given string represents a value that's valid input for the given node  */
    validateNumber(field, input) {
        const parsedNumber = this.parseNumber(input);
        return parsedNumber != undefined
            ? this.validateInput(field, parsedNumber)
            : { valid: false, empty: false, lowerLimitExceeded: false, upperLimitExceeded: false };
    },
    asNodeInput: function (number) {
        return { type: "NUMBER", number: number };
    },
    getNumberConstraints: function (field) {
        var _a;
        return {
            minValue: field.minValue,
            maxValue: field.maxValue,
            integersOnly: (_a = field.integersOnly) !== null && _a !== void 0 ? _a : false
        };
    },
    valueFromNodeInput: function (input) {
        if (instanceOfNumberNodeInput(input)) {
            return input.number;
        }
        else
            return null;
    },
};

const SingleChoiceInputUtils = {
    asNodeInput: function (optionId) {
        return { type: "SINGLE_CHOICE", optionId: optionId };
    },
    validateInput: function (field, optionId) {
        return { valid: field.options.some(opt => opt.id == optionId) };
    },
    valueFromNodeInput: function (input) {
        if (isSingleChoiceNodeInput(input)) {
            return input.optionId;
        }
        else
            return null;
    }
};

const TextInputUtils = {
    validateInput: function (field, input) {
        const { minLength, maxLength, pattern } = this.getTextConstraints(field);
        const validation = {
            valid: false,
            upperLimitExceeded: maxLength != undefined && input.length > maxLength,
            lowerLimitExceeded: minLength != undefined && input.length < minLength,
            patternViolated: pattern != null && !input.match(pattern),
            valueConstraintViolated: false
        };
        if (field.stringValueType === "EMAIL") {
            validation.valueConstraintViolated = !validateEmail(input);
        }
        else if (field.stringValueType === "IBAN") {
            validation.valueConstraintViolated = !validateIban(input);
        }
        else if (field.stringValueType === "PHONE_NUMBER") {
            validation.valueConstraintViolated = !validatePhoneNumber(input);
        }
        else if (field.stringValueType === "JSON") {
            validation.valueConstraintViolated = !validateJson(input);
        }
        validation.valid = (!field.required || !!input.length)
            && !(validation.upperLimitExceeded || validation.lowerLimitExceeded || validation.patternViolated || validation.valueConstraintViolated);
        return validation;
    },
    asNodeInput: function (text) {
        return { type: "TEXT", text: text };
    },
    getTextConstraints: function (field) {
        return field;
    },
    shouldAllowMultilineText: function (field) {
        return field.displayType === TextDisplayType.AREA;
    },
    valueFromNodeInput: function (input) {
        if (isTextNodeInput(input)) {
            return input.text;
        }
        else
            return null;
    },
    cleanInput: function (text, fieldType) {
        if (fieldType === "IBAN" || fieldType === "PHONE_NUMBER") {
            return text.replace(/[-\s]/g, "");
        }
        return text;
    }
};
function validateEmail(input) {
    return /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/.test(input);
}
function validateIban(input) {
    if (/^DE/.test(input)) {
        return /^DE\d{20}$/.test(input);
    }
    else {
        return /^[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}$/.test(input);
    }
}
function validatePhoneNumber(input) {
    return /^(?:\+\d{5,}|\d{4,})$/.test(input);
}
function validateJson(input) {
    try {
        JSON.parse(input);
        return true;
    }
    catch (error) {
        return false;
    }
}

function isRequiredInputDataPresent(node, data, fileMap) {
    return node.inputFields.every(field => {
        return (!field.required && data[field.id] == null) || // field not required
            (data[field.id] != null && validateNodeInput(field, data[field.id], fileMap[field.id]).valid); // valid node input provided
    });
}
function containsInvalidInputData(node, data, fileMap) {
    return node.inputFields.some(field => {
        const input = data[field.id];
        return input != null && !validateNodeInput(field, input, fileMap[field.id]).valid;
    });
}
function containsNonEmptyInputData(node, data, fileMap) {
    return !!Object.entries(data).find(e => {
        const inputField = node.inputFields.find(field => String(field.id) == e[0]);
        return !!inputField && (!isEmptyInput(e[1]) || !!fileMap[e[0]]);
    });
}
function validateNodeInput(field, input, file) {
    switch (input.type) {
        case "EMPTY":
            if (field.valueType === "FILE" && file)
                return FileInputUtils.validateInput(field, file);
            else
                return { valid: !field.required };
        case "BOOLEAN":
            return BooleanInputUtils.validateInput(field, input.value);
        case "DATE":
            return DateInputUtils.validateDate(field, input.date);
        case "NUMBER":
            return NumberInputUtils.validateInput(field, input.number);
        case "TEXT":
            return TextInputUtils.validateInput(field, input.text);
        case "FILE":
            return FileInputUtils.validateInput(field, input.file);
        case "SINGLE_CHOICE":
            return SingleChoiceInputUtils.validateInput(field, input.optionId);
        case "MULTIPLE_CHOICE":
            return MultipleChoiceInputUtils.validateInput(field, input.selectedOptionIds);
        case "DYNAMIC_CHOICE":
            return DynamicChoiceInputUtils.validateInput(field, { key: input.key, label: input.label });
        default:
            return { valid: false };
    }
}
function isInputRequired(node) {
    if (isInputNode(node)) {
        return node.inputFields.some(field => field.required);
    }
    return false;
}
function isEmptyInput(input) {
    return input.type == "EMPTY";
}
function createEmptyNodeInput() {
    return { type: "EMPTY" };
}

// Route definitions for KNS API
/* eslint-disable  @typescript-eslint/no-explicit-any */
function createApiRoutes(apiUrl) {
    const runApi = new RunsApi(new Configuration({ basePath: apiUrl }));
    return {
        start: (modelId, data) => apiCall(() => runApi.startRun({ modelId, body: data })),
    };
}
function createRunApiRoutes(apiUrl, runId) {
    const runApi = new RunsApi(new Configuration({ basePath: apiUrl }));
    const filesApi = new FilesApi(new Configuration({ basePath: apiUrl }));
    return {
        get: () => apiCall(() => runApi.getRun({ runId, xCDCTimezone: getTimezone() })),
        submit: (data) => apiCall(() => runApi.submitRun({ runId: runId, runSubmitData: { targetNodeType: "INPUT", inputMap: data } })),
        sendChatMessage: (data) => apiCall(() => runApi.submitRun({ runId, runSubmitData: Object.assign({ targetNodeType: "CHAT" }, data) })),
        go: (historyIdx) => apiCall(() => runApi.goToHistoryIdx({ runId, historyIdx })),
        Files: {
            uploadFile: (file) => apiCall(() => filesApi.uploadFile({ data: file }).then(res => res.file)),
            getFileDownloadUrl: (fileId, token) => `${apiUrl}/api/files/get/${fileId}?token=${token}`,
        }
    };
}
// In temporal descending order, i.e. first retry takes A[A.length - 1] ms
const API_CALL_RETRY_DELAYS = [10000, 7000, 5000, 3000, 3000, 1000];
function apiCall(buildRequest, retryMax = API_CALL_RETRY_DELAYS.length) {
    // Call the API
    return buildRequest()
        .catch(err => {
        // If we have a network error, retry
        const isNetworkError = (err === null || err === void 0 ? void 0 : err.name) === "FetchError";
        if (isNetworkError && retryMax > 0) {
            const retryDelay = API_CALL_RETRY_DELAYS[Math.min(Math.max(retryMax - 1, 0), API_CALL_RETRY_DELAYS.length - 1)];
            console.warn(`API call failed (network), retrying in ${retryDelay}ms`);
            return new Promise((res, rej) => {
                setTimeout(() => apiCall(buildRequest, retryMax - 1).then(res).catch(rej), retryDelay);
            });
        }
        else {
            return mapError(err).then(e => { throw e; });
        }
    });
}
function mapError(error) {
    return new Promise(res => {
        var _a, _b;
        function createApiError(text) {
            res({ error: text, type: "ERROR", data: error });
        }
        if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) != null && typeof error.response.text === "function") {
            // Error is HTTP response
            (error === null || error === void 0 ? void 0 : error.response).text()
                .then(bodyText => createApiError(`Received unexpected HTTP status ${error.response.status} and message: ${bodyText}`))
                .catch(() => createApiError(`Received unexpected HTTP status ${error.response.status}`));
        }
        else {
            res({ error: (_b = error === null || error === void 0 ? void 0 : error.toString()) !== null && _b !== void 0 ? _b : "Unknown error (error object was null)", type: "ERROR", data: error });
        }
    });
}
function asApiError(err) {
    return { error: err, type: "ERROR" };
}
function getTimezone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

function getCommaCharacter(locale) {
    locale = locale ? locale.replace(/_/g, "-") : locale;
    return (1.1).toLocaleString(locale).replace(/1/g, "");
}

function createRunsApi(params) {
    return new RunsApi(new Configuration(params));
}
function createFilesApi(params) {
    return new FilesApi(new Configuration(params));
}
function createConfigApi(params) {
    return new ConfigApi(new Configuration(params));
}
function fileMapToNodeInput(runId, upload, data, files) {
    const filesToUpload = Object.entries(files).filter(tuple => !!tuple[1]);
    return Promise.all(filesToUpload.map(tuple => upload(tuple[1], runId)))
        .then(sources => {
        // Map created file sources to their respective node inputs
        filesToUpload.forEach((tuple, idx) => {
            data[tuple[0]] = FileInputUtils.asNodeInput(sources[idx]);
        });
        return data;
    });
}

/**
 * The reader module provides tools to easily interact with the KNS API.
 */
/**
 * ReaderModule provides an interface to the ReaderAPI using ApiRoutes.
 * It also provides callbacks to react to run state changes, including
 * polling (where necessary).
 */
class ReaderModule {
    constructor(conf) {
        var _a, _b;
        Object.defineProperty(this, "_config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_routes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_run", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_pollOnRunWaiting", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_skipPassiveNodes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_messageListener", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._config = conf;
        this._pollOnRunWaiting = (_a = conf.pollOnRunWaiting) !== null && _a !== void 0 ? _a : false;
        this._skipPassiveNodes = (_b = conf.skipPassiveNodes) !== null && _b !== void 0 ? _b : false;
        this._messageListener = (event) => {
            const canReceive = this.getApiRoutes() != null
                && this._config.runId
                && event.data.targetRunId === this._config.runId;
            if (canReceive && event.data.type === "RELOAD") {
                this.updateRunState();
            }
        };
        window.addEventListener("message", this._messageListener);
        if (conf.runId != null) {
            // Continue existing run
            this._routes = createRunApiRoutes(this._config.apiUrl, conf.runId);
            this.updateRunState();
        }
        else if (conf.modelId) {
            this._log("Start run", "No runId present, starting new run for model" + conf.modelId);
            this._routes = createRunApiRoutes(this._config.apiUrl, ""); // TODO this is not beautiful, but we need to initialize
            // Start new run
            createApiRoutes(this._config.apiUrl).start(conf.modelId)
                .then((rsr) => {
                this._config.runId = rsr.runId;
                this._routes = createRunApiRoutes(this._config.apiUrl, rsr.runId);
                this.updateRunState();
            });
        }
        else {
            throw "Specify either runId or modelId when initializing ReaderModule";
        }
    }
    setEventHandlers(eventHandlers) {
        this._config.eventHandlers = eventHandlers;
    }
    // --- Getters
    getRunId() {
        return this._config.runId;
    }
    getApiRoutes() {
        return this._routes;
    }
    getRun() {
        return this._run;
    }
    // --- Interaction methods
    updateRunState() {
        var _a, _b;
        this._log("Update run state", "RunState update requested");
        (_b = (_a = this._config.eventHandlers) === null || _a === void 0 ? void 0 : _a.onApiRequest) === null || _b === void 0 ? void 0 : _b.call(_a);
        this.getApiRoutes().get()
            .then(this._poll.bind(this))
            .then(this._handleRunUpdated.bind(this))
            .catch(this._handleError.bind(this));
    }
    /**
     * Prepare values for submission, then submit them
     * @param data Node data to submit
     * @param files Files to upload for file inputs
     */
    prepareAndSubmit(data, files) {
        var _a, _b;
        // Gather files to upload
        const filesToUpload = Object.entries(files).filter(tuple => !!tuple[1]);
        // Notify an API request will be made
        (_b = (_a = this._config.eventHandlers) === null || _a === void 0 ? void 0 : _a.onApiRequest) === null || _b === void 0 ? void 0 : _b.call(_a);
        this._log("Submit", "Submit requested" + (files.length ? ", uploading " + filesToUpload.length + " files" : ""));
        fileMapToNodeInput(this._config.runId, this.getApiRoutes().Files.uploadFile, data, files)
            .then(updated => {
            // Submit data
            this._log("Submit", "Submitting " + Object.keys(updated).length + " argument(s): " + JSON.stringify(updated));
            this.getApiRoutes().submit(updated)
                .then(this._poll.bind(this))
                .then(this._handleRunUpdated.bind(this))
                .catch(this._handleError.bind(this));
        }).catch(e => {
            this._log("prepareAndSubmit", "File upload failed for some files: " + JSON.stringify(e), LogLevel.ERROR);
            this._handleError({
                type: "ERROR",
                error: "File upload failed for some files: " + JSON.stringify(e),
                nodeId: undefined
            });
        });
    }
    /**
     * Send a chat message at a chat node.
     * @param message The message to send
     */
    sendChatMessage(data) {
        var _a, _b;
        // Notify an API request will be made
        (_b = (_a = this._config.eventHandlers) === null || _a === void 0 ? void 0 : _a.onApiRequest) === null || _b === void 0 ? void 0 : _b.call(_a);
        this._log("Send chat message", "Sending chat message: \"" + data.message + "\"" + data.actionId ? ("| ActionID: " + data.actionId) : "");
        this.getApiRoutes()
            .sendChatMessage(data)
            .then(this._poll.bind(this))
            .then(this._handleRunUpdated.bind(this))
            .catch(this._handleError.bind(this));
    }
    go(historyIdx) {
        var _a, _b;
        this._log("Move back in run to", historyIdx);
        (_b = (_a = this._config.eventHandlers) === null || _a === void 0 ? void 0 : _a.onApiRequest) === null || _b === void 0 ? void 0 : _b.call(_a);
        this.getApiRoutes().go(historyIdx)
            .then(this._poll.bind(this))
            .then(this._handleRunUpdated.bind(this))
            .catch(this._handleError.bind(this));
    }
    // ---- Internal
    _handleRunUpdated(run) {
        var _a;
        // Set modelId if not present yet
        if (!this._config.modelId) {
            this._config.modelId = run.state.modelId;
        }
        // Log run
        this._log("Update run state", "Done.");
        // Save run
        this._run = run;
        // Notify callback
        (_a = this._config.eventHandlers) === null || _a === void 0 ? void 0 : _a.onRunUpdated(run);
        return run;
    }
    _handleError(error) {
        var _a;
        // Notify callback
        (_a = this._config.eventHandlers) === null || _a === void 0 ? void 0 : _a.onError(error);
        this._log("Api error", error, LogLevel.ERROR);
    }
    didRunChange(oldRun, newRun) {
        var _a, _b, _c, _d, _e, _f, _g;
        // Check for changes by comparing history idx
        return (newRun && !oldRun) || (newRun && oldRun && oldRun.state.history.path.length != newRun.state.history.path.length)
            || (newRun && oldRun && (!!newRun.result != !!oldRun.result))
            || ((!!((_a = newRun === null || newRun === void 0 ? void 0 : newRun.state) === null || _a === void 0 ? void 0 : _a.waitingState)) !== (!!((_b = oldRun === null || oldRun === void 0 ? void 0 : oldRun.state) === null || _b === void 0 ? void 0 : _b.waitingState)))
            || (((_c = newRun === null || newRun === void 0 ? void 0 : newRun.state) === null || _c === void 0 ? void 0 : _c.node) && isModelNode((_d = newRun === null || newRun === void 0 ? void 0 : newRun.state) === null || _d === void 0 ? void 0 : _d.node)
                && ((_e = oldRun === null || oldRun === void 0 ? void 0 : oldRun.state) === null || _e === void 0 ? void 0 : _e.node) && isModelNode(oldRun.state.node)
                && ((_f = newRun.state.node.dispatchSteps) === null || _f === void 0 ? void 0 : _f.length) !== ((_g = oldRun.state.node.dispatchSteps) === null || _g === void 0 ? void 0 : _g.length));
    }
    _delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    // poll run state until there is a valid state (or don't if already valid)
    _poll(prev) {
        if (prev.error === true) { // Run has error
            return Promise.reject("Error in run execution");
        }
        else if (prev.result) { // Run is finished
            return Promise.resolve(prev);
        }
        else if (prev.state.node || !!prev.state.waitingState) { // There is a display node or run is waiting
            if (this._pollOnRunWaiting && !!prev.state.waitingState) { // Run is waiting, poll
                // If we're waiting at a model node, update the run state once to be at the model node before polling.
                // Also, if we haven't loaded the run at all yet (e.g. opening the reader for a waiting run), do it here once.
                if (this.didRunChange(this._run, prev)) {
                    this._handleRunUpdated(prev);
                }
                return this._delay(1000)
                    .then(_ => this.getApiRoutes().get())
                    .then(next => this._poll(next));
            }
            else if (this._skipPassiveNodes && isDisplayNode(prev.state.node) && !prev.state.node.isEndNode) { // skipping passive nodes
                return this.getApiRoutes()
                    .submit({})
                    .then(next => this._poll(next));
            }
            else {
                return Promise.resolve(prev);
            }
        }
        else { // run is active, execution has not finished yet
            return this._delay(750)
                .then(_ => this.getApiRoutes().get())
                .then(next => this._poll(next));
        }
    }
    _log(prefix, message, level = LogLevel.INFO) {
        if (level === LogLevel.SILENT) {
            throw "ReaderModule -> Logging :: Cannot log at level SILENT";
        }
        const configuredLogLevel = this._config.logLevel || LogLevel.SILENT;
        if (LogLevelOrder.indexOf(configuredLogLevel) <= LogLevelOrder.indexOf(level)) {
            const msgAsString = message
                ? (" :: " + (typeof message === "string" ? message : JSON.stringify(message)))
                : "";
            const logMsg = "ReaderModule -> " + prefix + msgAsString;
            switch (level) {
                case LogLevel.INFO:
                    console.info(logMsg);
                    break;
                case LogLevel.WARN:
                    console.warn(logMsg);
                    break;
                case LogLevel.ERROR:
                    console.error(logMsg);
                    break;
            }
        }
    }
}
// Logging
var LogLevel;
(function (LogLevel) {
    LogLevel["INFO"] = "INFO";
    LogLevel["WARN"] = "WARN";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["SILENT"] = "SILENT";
})(LogLevel || (LogLevel = {}));
const LogLevelOrder = [LogLevel.INFO, LogLevel.WARN, LogLevel.ERROR, LogLevel.SILENT];

function openTab(url) {
    // Create link in memory
    const a = window.document.createElement("a");
    a.target = "_blank";
    a.href = url;
    // Dispatch fake click
    const e = window.document.createEvent("MouseEvents");
    e.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    a.dispatchEvent(e);
}
function richToPlain(text) {
    if (text) {
        const el = document.createElement("div");
        el.innerHTML = text;
        return el.textContent;
    }
    return text;
}
function smoothScrollTo(element, position, duration = 200, direction = "y") {
    const scrollField = direction == "y" ? "scrollTop" : "scrollLeft";
    const from = element[scrollField];
    const diff = position - from;
    let startTime = 0;
    const step = (timestamp) => {
        if (!startTime) {
            startTime = timestamp;
        }
        const progress = (timestamp - startTime) / duration;
        const animatedProgress = -Math.pow((progress - 1), 2) + 1; // Cubic easing
        element[scrollField] = from + diff * animatedProgress;
        if (progress < 1) {
            window.requestAnimationFrame(step);
        }
    };
    window.requestAnimationFrame(step);
}
function isMobileBrowser() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export { ApiExchangeMissingExecutionErrorFromJSON, ApiExchangeMissingExecutionErrorFromJSONTyped, ApiExchangeMissingExecutionErrorToJSON, ApiExchangeMissingExecutionErrorTypeEnum, AttributeValueType, AttributeValueTypeFromJSON, AttributeValueTypeFromJSONTyped, AttributeValueTypeToJSON, BASE_PATH, BaseAPI, BaseChoiceFromJSON, BaseChoiceFromJSONTyped, BaseChoiceToJSON, BlobApiResponse, BooleanDataValueAllOf1FromJSON, BooleanDataValueAllOf1FromJSONTyped, BooleanDataValueAllOf1ToJSON, BooleanDataValueAllOf1TypeEnum, BooleanDataValueAllOfFromJSON, BooleanDataValueAllOfFromJSONTyped, BooleanDataValueAllOfToJSON, BooleanDataValueFromJSON, BooleanDataValueFromJSONTyped, BooleanDataValueToJSON, BooleanDataValueTypeEnum, BooleanDisplayType, BooleanDisplayTypeFromJSON, BooleanDisplayTypeFromJSONTyped, BooleanDisplayTypeToJSON, BooleanInputFieldFromJSON, BooleanInputFieldFromJSONTyped, BooleanInputFieldToJSON, BooleanInputFieldValueTypeEnum, BooleanInputUtils, BooleanNodeInputFromJSON, BooleanNodeInputFromJSONTyped, BooleanNodeInputToJSON, BooleanNodeInputTypeEnum, COLLECTION_FORMATS, ChatActionOutlineFromJSON, ChatActionOutlineFromJSONTyped, ChatActionOutlineToJSON, ChatMessageFromJSON, ChatMessageFromJSONTyped, ChatMessageToJSON, ChatNodeDataFromJSON, ChatNodeDataFromJSONTyped, ChatNodeDataTargetNodeTypeEnum, ChatNodeDataToJSON, ChatNodeFromJSON, ChatNodeFromJSONTyped, ChatNodeNodeTypeEnum, ChatNodeToJSON, ChoiceFromJSON, ChoiceFromJSONTyped, ChoiceToJSON, ColorConfigFromJSON, ColorConfigFromJSONTyped, ColorConfigToJSON, ConfigApi, Configuration, ContainerDataNodeFromJSON, ContainerDataNodeFromJSONTyped, ContainerDataNodeToJSON, ContainerDataNodeTypeEnum, CustomAttributeValueFromJSON, CustomAttributeValueFromJSONTyped, CustomAttributeValueToJSON, DataFieldConstraintViolationExecutionErrorFromJSON, DataFieldConstraintViolationExecutionErrorFromJSONTyped, DataFieldConstraintViolationExecutionErrorToJSON, DataFieldConstraintViolationExecutionErrorTypeEnum, DataFieldOutlineFromJSON, DataFieldOutlineFromJSONTyped, DataFieldOutlineToJSON, DataFieldType, DataFieldTypeFromJSON, DataFieldTypeFromJSONTyped, DataFieldTypeToJSON, DataNodeFromJSON, DataNodeFromJSONTyped, DataNodeToJSON, DataNodeType, DataNodeTypeFromJSON, DataNodeTypeFromJSONTyped, DataNodeTypeToJSON, DataValueFromJSON, DataValueFromJSONTyped, DataValueToJSON, DataValueType, DataValueTypeFromJSON, DataValueTypeFromJSONTyped, DataValueTypeToJSON, DateDataValueAllOf1FromJSON, DateDataValueAllOf1FromJSONTyped, DateDataValueAllOf1ToJSON, DateDataValueAllOf1TypeEnum, DateDataValueAllOfFromJSON, DateDataValueAllOfFromJSONTyped, DateDataValueAllOfToJSON, DateDataValueFromJSON, DateDataValueFromJSONTyped, DateDataValueToJSON, DateDataValueTypeEnum, DateFormats, DateInputFieldFromJSON, DateInputFieldFromJSONTyped, DateInputFieldToJSON, DateInputFieldValueTypeEnum, DateInputUtils, DateNodeInputFromJSON, DateNodeInputFromJSONTyped, DateNodeInputToJSON, DateNodeInputTypeEnum, DefaultConfig, DisplayNodeFromJSON, DisplayNodeFromJSONTyped, DisplayNodeNodeTypeEnum, DisplayNodeToJSON, DynamicChoiceApi, DynamicChoiceInputFieldFromJSON, DynamicChoiceInputFieldFromJSONTyped, DynamicChoiceInputFieldToJSON, DynamicChoiceInputFieldValueTypeEnum, DynamicChoiceInputUtils, DynamicChoiceNodeInputFromJSON, DynamicChoiceNodeInputFromJSONTyped, DynamicChoiceNodeInputToJSON, DynamicChoiceNodeInputTypeEnum, DynamicChoiceOptionFromJSON, DynamicChoiceOptionFromJSONTyped, DynamicChoiceOptionToJSON, EmptyNodeInputFromJSON, EmptyNodeInputFromJSONTyped, EmptyNodeInputToJSON, EmptyNodeInputTypeEnum, ErrorExecutionResultFromJSON, ErrorExecutionResultFromJSONTyped, ErrorExecutionResultToJSON, EvaluatedDataTableFieldFromJSON, EvaluatedDataTableFieldFromJSONTyped, EvaluatedDataTableFieldToJSON, EvaluatedDataTableFromJSON, EvaluatedDataTableFromJSONTyped, EvaluatedDataTableToJSON, EvaluatedDataTableTypeEnum, EvaluatedReportFromJSON, EvaluatedReportFromJSONTyped, EvaluatedReportToJSON, EvaluatedReportTypeEnum, EvaluatedSectionFromJSON, EvaluatedSectionFromJSONTyped, EvaluatedSectionToJSON, EvaluatedSectionsFromJSON, EvaluatedSectionsFromJSONTyped, EvaluatedSectionsToJSON, ExecutionErrorFromJSON, ExecutionErrorFromJSONTyped, ExecutionErrorToJSON, FetchError, FileDataValueAllOf1FromJSON, FileDataValueAllOf1FromJSONTyped, FileDataValueAllOf1ToJSON, FileDataValueAllOf1TypeEnum, FileDataValueAllOfFromJSON, FileDataValueAllOfFromJSONTyped, FileDataValueAllOfToJSON, FileDataValueFromJSON, FileDataValueFromJSONTyped, FileDataValueToJSON, FileDataValueTypeEnum, FileInputFieldFromJSON, FileInputFieldFromJSONTyped, FileInputFieldToJSON, FileInputFieldValueTypeEnum, FileInputUtils, FileNodeInputFromJSON, FileNodeInputFromJSONTyped, FileNodeInputToJSON, FileNodeInputTypeEnum, FileReferenceFromJSON, FileReferenceFromJSONTyped, FileReferenceToJSON, FileResponseFromJSON, FileResponseFromJSONTyped, FileResponseToJSON, FilesApi, FontConfigFromJSON, FontConfigFromJSONTyped, FontConfigToJSON, GetModelInterfaceRequestFromJSON, GetModelInterfaceRequestFromJSONTyped, GetModelInterfaceRequestToJSON, HeadingLevel, HeadingLevelFromJSON, HeadingLevelFromJSONTyped, HeadingLevelToJSON, HistoryStepFromJSON, HistoryStepFromJSONTyped, HistoryStepToJSON, InfoContentFromJSON, InfoContentFromJSONTyped, InfoContentToJSON, InputFieldFromJSON, InputFieldFromJSONTyped, InputFieldToJSON, InputFieldsMissingExecutionErrorFromJSON, InputFieldsMissingExecutionErrorFromJSONTyped, InputFieldsMissingExecutionErrorToJSON, InputFieldsMissingExecutionErrorTypeEnum, InputNodeDataFromJSON, InputNodeDataFromJSONTyped, InputNodeDataTargetNodeTypeEnum, InputNodeDataToJSON, InputNodeFromJSON, InputNodeFromJSONTyped, InputNodeNodeTypeEnum, InputNodeToJSON, InternalExecutionErrorFromJSON, InternalExecutionErrorFromJSONTyped, InternalExecutionErrorToJSON, InternalExecutionErrorTypeEnum, JSONApiResponse, KNSFileFromJSON, KNSFileFromJSONTyped, KNSFileToJSON, ListType, ListTypeFromJSON, ListTypeFromJSONTyped, ListTypeToJSON, LogLevel, LogicScriptFailedCompilationExecutionErrorFromJSON, LogicScriptFailedCompilationExecutionErrorFromJSONTyped, LogicScriptFailedCompilationExecutionErrorToJSON, LogicScriptFailedCompilationExecutionErrorTypeEnum, LogicScriptFailedRuntimeExecutionErrorFromJSON, LogicScriptFailedRuntimeExecutionErrorFromJSONTyped, LogicScriptFailedRuntimeExecutionErrorToJSON, LogicScriptFailedRuntimeExecutionErrorTypeEnum, LogicScriptFailedTimeoutExecutionErrorFromJSON, LogicScriptFailedTimeoutExecutionErrorFromJSONTyped, LogicScriptFailedTimeoutExecutionErrorToJSON, LogicScriptFailedTimeoutExecutionErrorTypeEnum, LogicScriptMissingValueExecutionErrorFromJSON, LogicScriptMissingValueExecutionErrorFromJSONTyped, LogicScriptMissingValueExecutionErrorToJSON, LogicScriptMissingValueExecutionErrorTypeEnum, ModelInterfaceFromJSON, ModelInterfaceFromJSONTyped, ModelInterfaceToJSON, ModelNodeDispatchStepFromJSON, ModelNodeDispatchStepFromJSONTyped, ModelNodeDispatchStepToJSON, ModelNodeFromJSON, ModelNodeFromJSONTyped, ModelNodeNodeTypeEnum, ModelNodeToJSON, ModelNotFoundExecutionErrorFromJSON, ModelNotFoundExecutionErrorFromJSONTyped, ModelNotFoundExecutionErrorToJSON, ModelNotFoundExecutionErrorTypeEnum, ModelSignatureFromJSON, ModelSignatureFromJSONTyped, ModelSignatureToJSON, MultipleChoiceInputFieldFromJSON, MultipleChoiceInputFieldFromJSONTyped, MultipleChoiceInputFieldToJSON, MultipleChoiceInputFieldValueTypeEnum, MultipleChoiceInputUtils, MultipleChoiceNodeInputFromJSON, MultipleChoiceNodeInputFromJSONTyped, MultipleChoiceNodeInputToJSON, MultipleChoiceNodeInputTypeEnum, NodeFromJSON, NodeFromJSONTyped, NodeInputFromJSON, NodeInputFromJSONTyped, NodeInputToJSON, NodeToJSON, NumberDataValueAllOf1FromJSON, NumberDataValueAllOf1FromJSONTyped, NumberDataValueAllOf1ToJSON, NumberDataValueAllOf1TypeEnum, NumberDataValueAllOfFromJSON, NumberDataValueAllOfFromJSONTyped, NumberDataValueAllOfToJSON, NumberDataValueFromJSON, NumberDataValueFromJSONTyped, NumberDataValueToJSON, NumberDataValueTypeEnum, NumberInputFieldFromJSON, NumberInputFieldFromJSONTyped, NumberInputFieldToJSON, NumberInputFieldValueTypeEnum, NumberInputUtils, NumberNodeInputFromJSON, NumberNodeInputFromJSONTyped, NumberNodeInputToJSON, NumberNodeInputTypeEnum, Object88998051FromJSON, Object88998051FromJSONTyped, Object88998051ToJSON, PartyRoleDataUpdateFromJSON, PartyRoleDataUpdateFromJSONTyped, PartyRoleDataUpdateToJSON, ReaderModule, RequiredError, ResponseError, RichTextDataFieldNodeFromJSON, RichTextDataFieldNodeFromJSONTyped, RichTextDataFieldNodeToJSON, RichTextDataFieldNodeTypeEnum, RichTextDataValueAllOf1FromJSON, RichTextDataValueAllOf1FromJSONTyped, RichTextDataValueAllOf1ToJSON, RichTextDataValueAllOf1TypeEnum, RichTextDataValueAllOfFromJSON, RichTextDataValueAllOfFromJSONTyped, RichTextDataValueAllOfToJSON, RichTextDataValueFromJSON, RichTextDataValueFromJSONTyped, RichTextDataValueToJSON, RichTextDataValueTypeEnum, RichTextLineBreakNodeFromJSON, RichTextLineBreakNodeFromJSONTyped, RichTextLineBreakNodeToJSON, RichTextLineBreakNodeTypeEnum, RichTextLinkNodeFromJSON, RichTextLinkNodeFromJSONTyped, RichTextLinkNodeToJSON, RichTextLinkNodeTypeEnum, RichTextListItemNodeFromJSON, RichTextListItemNodeFromJSONTyped, RichTextListItemNodeToJSON, RichTextListItemNodeTypeEnum, RichTextListNodeFromJSON, RichTextListNodeFromJSONTyped, RichTextListNodeToJSON, RichTextListNodeTypeEnum, RichTextNodeFromJSON, RichTextNodeFromJSONTyped, RichTextNodeToJSON, RichTextParagraphNodeFromJSON, RichTextParagraphNodeFromJSONTyped, RichTextParagraphNodeToJSON, RichTextParagraphNodeTypeEnum, RichTextRootNodeFromJSON, RichTextRootNodeFromJSONTyped, RichTextRootNodeToJSON, RichTextRootNodeTypeEnum, RichTextTableCellNodeFromJSON, RichTextTableCellNodeFromJSONTyped, RichTextTableCellNodeToJSON, RichTextTableCellNodeTypeEnum, RichTextTableNodeFromJSON, RichTextTableNodeFromJSONTyped, RichTextTableNodeToJSON, RichTextTableNodeTypeEnum, RichTextTableRowNodeFromJSON, RichTextTableRowNodeFromJSONTyped, RichTextTableRowNodeToJSON, RichTextTableRowNodeTypeEnum, RichTextTextNodeFromJSON, RichTextTextNodeFromJSONTyped, RichTextTextNodeToJSON, RichTextTextNodeTypeEnum, RootDataNodeAllOf1FromJSON, RootDataNodeAllOf1FromJSONTyped, RootDataNodeAllOf1ToJSON, RootDataNodeAllOf1TypeEnum, RootDataNodeAllOfFromJSON, RootDataNodeAllOfFromJSONTyped, RootDataNodeAllOfToJSON, RootDataNodeAllOfTypeEnum, RootDataNodeFromJSON, RootDataNodeFromJSONTyped, RootDataNodeToJSON, RootDataNodeTypeEnum, RunHistoryFromJSON, RunHistoryFromJSONTyped, RunHistoryToJSON, RunInfoFromJSON, RunInfoFromJSONTyped, RunInfoToJSON, RunInfosForModelFromJSON, RunInfosForModelFromJSONTyped, RunInfosForModelToJSON, RunMode, RunModeFromJSON, RunModeFromJSONTyped, RunModeToJSON, RunResultFromJSON, RunResultFromJSONTyped, RunResultToJSON, RunScenarioApi, RunScenarioExecutionResultFromJSON, RunScenarioExecutionResultFromJSONTyped, RunScenarioExecutionResultToJSON, RunScenarioValidationResultFromJSON, RunScenarioValidationResultFromJSONTyped, RunScenarioValidationResultToJSON, RunScenarioValidationStopReasonFromJSON, RunScenarioValidationStopReasonFromJSONTyped, RunScenarioValidationStopReasonToJSON, RunStateFromJSON, RunStateFromJSONTyped, RunStateResponseFromJSON, RunStateResponseFromJSONTyped, RunStateResponseToJSON, RunStateToJSON, RunStatus, RunStatusFromJSON, RunStatusFromJSONTyped, RunStatusToJSON, RunSubmitDataFromJSON, RunSubmitDataFromJSONTyped, RunSubmitDataToJSON, RunWaitingStateFromJSON, RunWaitingStateFromJSONTyped, RunWaitingStateToJSON, RunsApi, ScenarioExecutableRequestFromJSON, ScenarioExecutableRequestFromJSONTyped, ScenarioExecutableRequestToJSON, ScopedRunsApi, ServiceApi, ServiceExchangeErrorFromJSON, ServiceExchangeErrorFromJSONTyped, ServiceExchangeErrorToJSON, SingleChoiceDisplayType, SingleChoiceDisplayTypeFromJSON, SingleChoiceDisplayTypeFromJSONTyped, SingleChoiceDisplayTypeToJSON, SingleChoiceInputFieldFromJSON, SingleChoiceInputFieldFromJSONTyped, SingleChoiceInputFieldToJSON, SingleChoiceInputFieldValueTypeEnum, SingleChoiceInputUtils, SingleChoiceNodeInputFromJSON, SingleChoiceNodeInputFromJSONTyped, SingleChoiceNodeInputToJSON, SingleChoiceNodeInputTypeEnum, StopReasonType, StopReasonTypeFromJSON, StopReasonTypeFromJSONTyped, StopReasonTypeToJSON, StringDataValueAllOf1FromJSON, StringDataValueAllOf1FromJSONTyped, StringDataValueAllOf1ToJSON, StringDataValueAllOf1TypeEnum, StringDataValueAllOfFromJSON, StringDataValueAllOfFromJSONTyped, StringDataValueAllOfToJSON, StringDataValueFromJSON, StringDataValueFromJSONTyped, StringDataValueToJSON, StringDataValueTypeEnum, StringValueType, StringValueTypeFromJSON, StringValueTypeFromJSONTyped, StringValueTypeToJSON, SystemChatMessageFromJSON, SystemChatMessageFromJSONTyped, SystemChatMessageToJSON, SystemChatMessageTypeEnum, TextAlignment, TextAlignmentFromJSON, TextAlignmentFromJSONTyped, TextAlignmentToJSON, TextApiResponse, TextDisplayType, TextDisplayTypeFromJSON, TextDisplayTypeFromJSONTyped, TextDisplayTypeToJSON, TextFormat, TextFormatFromJSON, TextFormatFromJSONTyped, TextFormatToJSON, TextInputFieldFromJSON, TextInputFieldFromJSONTyped, TextInputFieldToJSON, TextInputFieldValueTypeEnum, TextInputUtils, TextNodeInputFromJSON, TextNodeInputFromJSONTyped, TextNodeInputToJSON, TextNodeInputTypeEnum, TicketOutlineAttributesFromJSON, TicketOutlineAttributesFromJSONTyped, TicketOutlineAttributesToJSON, TicketReaderConfigFromJSON, TicketReaderConfigFromJSONTyped, TicketReaderConfigToJSON, TicketStateFromJSON, TicketStateFromJSONTyped, TicketStateToJSON, TicketStateUpdateFromJSON, TicketStateUpdateFromJSONTyped, TicketStateUpdateToJSON, TicketViewMilestoneFromJSON, TicketViewMilestoneFromJSONTyped, TicketViewMilestoneToJSON, TicketViewProgressFromJSON, TicketViewProgressFromJSONTyped, TicketViewProgressToJSON, TicketViewStepFromJSON, TicketViewStepFromJSONTyped, TicketViewStepToJSON, TicketsApi, TicketsDocumentProviderApi, TicketsModelProviderApi, UserChatMessageFromJSON, UserChatMessageFromJSONTyped, UserChatMessageToJSON, UserChatMessageTypeEnum, ValueDataNodeFromJSON, ValueDataNodeFromJSONTyped, ValueDataNodeToJSON, ValueDataNodeTypeEnum, VoidApiResponse, asApiError, canConsumeForm, containsInvalidInputData, containsNonEmptyInputData, createApiRoutes, createConfigApi, createDynamicChoiceApiRoutesFromUrl, createEmptyNodeInput, createFilesApi, createRunApiRoutes, createRunsApi, exists, fileMapToNodeInput, getCommaCharacter, instanceOfApiExchangeMissingExecutionError, instanceOfBaseChoice, instanceOfBooleanDataValue, instanceOfBooleanDataValueAllOf, instanceOfBooleanDataValueAllOf1, instanceOfBooleanInputField, instanceOfBooleanNodeInput, instanceOfChatActionOutline, instanceOfChatNode, instanceOfChatNodeData, instanceOfChoice, instanceOfColorConfig, instanceOfContainerDataNode, instanceOfCustomAttributeValue, instanceOfDataFieldConstraintViolationExecutionError, instanceOfDataFieldOutline, instanceOfDateDataValue, instanceOfDateDataValueAllOf, instanceOfDateDataValueAllOf1, instanceOfDateInputField, instanceOfDateNodeInput, instanceOfDisplayNode, instanceOfDynamicChoiceInputField, instanceOfDynamicChoiceNodeInput, instanceOfDynamicChoiceOption, instanceOfEmptyNodeInput, instanceOfErrorExecutionResult, instanceOfEvaluatedDataTable, instanceOfEvaluatedDataTableField, instanceOfEvaluatedReport, instanceOfEvaluatedSections, instanceOfFileDataValue, instanceOfFileDataValueAllOf, instanceOfFileDataValueAllOf1, instanceOfFileInputField, instanceOfFileNodeInput, instanceOfFileReference, instanceOfFileResponse, instanceOfFontConfig, instanceOfGetModelInterfaceRequest, instanceOfHistoryStep, instanceOfInfoContent, instanceOfInputFieldsMissingExecutionError, instanceOfInputNode, instanceOfInputNodeData, instanceOfInternalExecutionError, instanceOfKNSFile, instanceOfLogicScriptFailedCompilationExecutionError, instanceOfLogicScriptFailedRuntimeExecutionError, instanceOfLogicScriptFailedTimeoutExecutionError, instanceOfLogicScriptMissingValueExecutionError, instanceOfModelInterface, instanceOfModelNode, instanceOfModelNodeDispatchStep, instanceOfModelNotFoundExecutionError, instanceOfModelSignature, instanceOfMultipleChoiceInputField, instanceOfMultipleChoiceNodeInput, instanceOfNumberDataValue, instanceOfNumberDataValueAllOf, instanceOfNumberDataValueAllOf1, instanceOfNumberInputField, instanceOfNumberNodeInput, instanceOfObject88998051, instanceOfPartyRoleDataUpdate, instanceOfRichTextDataFieldNode, instanceOfRichTextDataValue, instanceOfRichTextDataValueAllOf, instanceOfRichTextDataValueAllOf1, instanceOfRichTextLineBreakNode, instanceOfRichTextLinkNode, instanceOfRichTextListItemNode, instanceOfRichTextListNode, instanceOfRichTextParagraphNode, instanceOfRichTextRootNode, instanceOfRichTextTableCellNode, instanceOfRichTextTableNode, instanceOfRichTextTableRowNode, instanceOfRichTextTextNode, instanceOfRootDataNode, instanceOfRootDataNodeAllOf, instanceOfRootDataNodeAllOf1, instanceOfRunHistory, instanceOfRunInfo, instanceOfRunInfosForModel, instanceOfRunResult, instanceOfRunScenarioExecutionResult, instanceOfRunScenarioValidationResult, instanceOfRunScenarioValidationStopReason, instanceOfRunState, instanceOfRunStateResponse, instanceOfRunWaitingState, instanceOfScenarioExecutableRequest, instanceOfServiceExchangeError, instanceOfSingleChoiceInputField, instanceOfSingleChoiceNodeInput, instanceOfStringDataValue, instanceOfStringDataValueAllOf, instanceOfStringDataValueAllOf1, instanceOfSystemChatMessage, instanceOfTextInputField, instanceOfTextNodeInput, instanceOfTicketOutlineAttributes, instanceOfTicketReaderConfig, instanceOfTicketState, instanceOfTicketStateUpdate, instanceOfTicketViewMilestone, instanceOfTicketViewProgress, instanceOfTicketViewStep, instanceOfUserChatMessage, instanceOfValueDataNode, isApiExchangeMissingExecutionError, isBooleanDataValue, isBooleanInputField, isBooleanNodeInput, isChatNode, isChatNodeData, isContainerDataNode, isDataFieldConstraintViolationExecutionError, isDateDataValue, isDateInputField, isDateNodeInput, isDisplayNode, isDynamicChoiceInputField, isDynamicChoiceNodeInput, isEmptyInput, isEmptyNodeInput, isEvaluatedDataTable, isEvaluatedReport, isFileDataValue, isFileInputField, isFileNodeInput, isInputFieldsMissingExecutionError, isInputNode, isInputNodeData, isInputRequired, isInternalExecutionError, isLogicScriptFailedCompilationExecutionError, isLogicScriptFailedRuntimeExecutionError, isLogicScriptFailedTimeoutExecutionError, isLogicScriptMissingValueExecutionError, isMobileBrowser, isModelNode, isModelNotFoundExecutionError, isMultipleChoiceInputField, isMultipleChoiceNodeInput, isNumberDataValue, isNumberInputField, isNumberNodeInput, isRequiredInputDataPresent, isRichTextDataFieldNode, isRichTextDataValue, isRichTextLineBreakNode, isRichTextLinkNode, isRichTextListItemNode, isRichTextListNode, isRichTextParagraphNode, isRichTextRootNode, isRichTextTableCellNode, isRichTextTableNode, isRichTextTableRowNode, isRichTextTextNode, isSingleChoiceInputField, isSingleChoiceNodeInput, isStringDataValue, isSystemChatMessage, isTextInputField, isTextNodeInput, isUserChatMessage, isValueDataNode, mapValues, openTab, querystring, richToPlain, smoothScrollTo, validateNodeInput };
